const pressRelease1 = {
  id: 1,
  passage: `FOR IMMEDIATE RELEASE

Department Launches Clean Air Initiative in Major Cities

In an effort to address rising air pollution levels in urban areas, the Department of Environmental Conservation has launched the Clean Air Urban Project (CAUP). The initiative aims to reduce <mark>emissions</mark>, expand green spaces, and encourage <mark>sustainable</mark> practices in major cities, starting with New York City, Los Angeles, and Chicago in early 2024.

"This project is a major step forward in protecting public health," said Secretary Addison Collins. CAUP will <mark>involve</mark> advanced emission-reduction technologies and collaboration with businesses and residents.

Details about project phases and specific <mark>measures</mark> will be announced in the coming weeks. The department plans to work closely with local governments and community leaders to ensure a smooth <mark>rollout</mark>.

For more information, contact Zoey Thompson at 316-555-7777 or Zoey@RadiantSphere.fict.`,

  translation: `즉시 보도용

주요 도시에서 청정 공기 이니셔티브 출범

도시 지역의 증가하는 대기 오염 수준에 대응하기 위한 노력으로, 환경보전부는 청정 공기 도시 프로젝트(CAUP)를 출범했습니다. 이 이니셔티브는 2024년 초 뉴욕시, 로스앤젤레스, 시카고를 시작으로 주요 도시에서 배출량을 줄이고, 녹지 공간을 확장하며, 지속 가능한 관행을 장려하는 것을 목표로 합니다.

"이 프로젝트는 공중 보건 보호에 있어 중요한 진전입니다,"라고 애디슨 콜린스 장관이 말했습니다. CAUP는 고급 배출 감소 기술과 기업 및 주민들과의 협력을 포함할 것입니다.

프로젝트 단계 및 구체적인 조치에 대한 세부 사항은 향후 몇 주 내에 발표될 예정입니다. 부서는 원활한 출시를 보장하기 위해 지방 정부 및 지역사회 지도자들과 긴밀히 협력할 계획입니다.

자세한 정보는 Zoey Thompson에게 316-555-7777 또는 Zoey@RadiantSphere.fict로 문의하십시오.`,

  koreanNouns: `FOR IMMEDIATE RELEASE

Department Launches Clean Air Initiative in Major Cities

In an effort to address rising air pollution levels in urban areas, the Department of Environmental Conservation has launched the Clean Air Urban Project (CAUP). The initiative aims to reduce <mark>배출량</mark>, expand green spaces, and encourage <mark>지속 가능한</mark> practices in major cities, starting with New York City, Los Angeles, and Chicago in early 2024.

"This project is a major step forward in protecting public health," said Secretary Addison Collins. CAUP will <mark>포함할</mark> advanced emission-reduction technologies and collaboration with businesses and residents.

Details about project phases and specific <mark>조치</mark> will be announced in the coming weeks. The department plans to work closely with local governments and community leaders to ensure a smooth <mark>출시</mark>.

For more information, contact Zoey Thompson at 316-555-7777 or Zoey@RadiantSphere.fict.`,

  wordPairs: {
    emissions: "배출량",
    involve: "포함할",
    sustainable: "지속 가능한",
    measures: "조치",
    rollout: "출시",
  },

  questions: [],
};

const pressRelease2 = {
  id: 2,
  passage: `FOR IMMEDIATE RELEASE

Nationwide "Unleashing Hope" Campaign Launches to Support Non-Profits

CHICAGO, IL - October 1, 2074 - Today marks the official launch of "Unleashing Hope," a nationwide fundraising campaign designed to provide critical support to non-profit organizations across <mark>diverse</mark> sectors including education, healthcare, and poverty elimination.

The campaign features a variety of <mark>engagement</mark> opportunities including charity marathons, social galas, and online auctions. An interactive digital platform has also been created to allow individuals to <mark>contribute</mark> in ways that align with their personal interests and abilities.

"We firmly believe that every cent counts in our mission to create positive change," said Campaign Director Eliza Washington. "This initiative aims to <mark>unite</mark> Americans through shared values of compassion and generosity."

Organizations benefiting from the campaign will receive funds through a <mark>transparent</mark> allocation process, with regular updates provided to donors and the public.

For more information about the Unleashing Hope Campaign, please contact Maya L. Jensen at (312) 555-7201 or maya.j@brightimpact.org.`,

  translation: `즉시 보도용

비영리 단체 지원을 위한 전국적인 "희망 펼치기" 캠페인 출범

시카고, 일리노이 - 2074년 10월 1일 - 오늘은 교육, 의료, 빈곤 퇴치 등 다양한 분야의 비영리 단체에 중요한 지원을 제공하기 위해 설계된 전국적인 모금 캠페인인 "희망 펼치기"의 공식 출범을 알리는 날입니다.

이 캠페인은 자선 마라톤, 사교 갈라, 온라인 경매 등 다양한 참여 기회를 제공합니다. 또한 개인이 자신의 개인적 관심사와 능력에 맞는 방식으로 기부할 수 있도록 대화형 디지털 플랫폼도 만들어졌습니다.

"우리는 긍정적인 변화를 만들어내는 사명에 있어 모든 한 푼이 중요하다고 굳게 믿습니다,"라고 캠페인 디렉터 엘리자 워싱턴이 말했습니다. "이 이니셔티브는 연민과 관대함의 공유된 가치를 통해 미국인들을 단결시키는 것을 목표로 합니다."

캠페인의 혜택을 받는 단체들은 투명한 할당 과정을 통해 자금을 받게 되며, 기부자와 대중에게 정기적인 업데이트가 제공될 것입니다.

희망 펼치기 캠페인에 대한 자세한 정보는 마야 L. 젠슨에게 (312) 555-7201 또는 maya.j@brightimpact.org로 문의하십시오.`,

  koreanNouns: `FOR IMMEDIATE RELEASE

Nationwide "Unleashing Hope" Campaign Launches to Support Non-Profits

CHICAGO, IL - October 1, 2074 - Today marks the official launch of "Unleashing Hope," a nationwide fundraising campaign designed to provide critical support to non-profit organizations across <mark>다양한</mark> sectors including education, healthcare, and poverty elimination.

The campaign features a variety of <mark>참여</mark> opportunities including charity marathons, social galas, and online auctions. An interactive digital platform has also been created to allow individuals to <mark>기부할</mark> in ways that align with their personal interests and abilities.

"We firmly believe that every cent counts in our mission to create positive change," said Campaign Director Eliza Washington. "This initiative aims to <mark>단결시키다</mark> Americans through shared values of compassion and generosity."

Organizations benefiting from the campaign will receive funds through a <mark>투명한</mark> allocation process, with regular updates provided to donors and the public.

For more information about the Unleashing Hope Campaign, please contact Maya L. Jensen at (312) 555-7201 or maya.j@brightimpact.org.`,

  wordPairs: {
    diverse: "다양한",
    engagement: "참여",
    contribute: "기부할",
    unite: "단결시키다",
    transparent: "투명한",
  },

  questions: [],
};

const pressRelease3 = {
  id: 3,
  passage: `FOR IMMEDIATE RELEASE

LuminaCore Industries Welcomes New HR Leader

ARGYLE, TEXAS - January 1, 2060 - We are excited to announce a new addition to our team at LuminaCore Industries. A major step towards delivering on our promise of providing a better working environment and culture, Kathy Glass, an experienced Human Resources professional, has been hired as our new HR leader.

The new appointment reflects our commitment and vision toward establishing a new standard of excellence in the organization. As an experienced HR professional with a <mark>proven</mark> track record, Kathy Glass will be <mark>instrumental</mark> in <mark>strengthening</mark> our framework and <mark>evolving</mark> the department's strategic role within the company.

The management believes that Kathy Glass brings valuable insights and fresh <mark>perspectives</mark> that will drive our organization's success. Their primary focus will be developing and implementing HR strategies that align with the company's overall mission and vision.

We believe in investing in and <mark>nurturing</mark> our people, and hence, we're confident that Kathy Glass is the right fit for this role, contributing to our virtue of mutual growth.

We <mark>wholeheartedly</mark> welcome Kathy Glass. Their addition is not just a new chapter in our company's journey but a significant milestone that signals growth and progress.`,

  translation: `즉시 보도용

루미나코어 인더스트리스, 새로운 인사 리더 환영

아가일, 텍사스 - 2060년 1월 1일 - 루미나코어 인더스트리스에 새로운 팀원이 합류하게 되어 기쁘게 생각합니다. 더 나은 근무 환경과 문화를 제공하겠다는 우리의 약속을 이행하기 위한 중요한 단계로, 경험이 풍부한 인사 전문가인 캐시 글래스가 새로운 인사 리더로 채용되었습니다.

이번 새로운 임명은 조직 내 우수성의 새로운 기준을 확립하려는 우리의 약속과 비전을 반영합니다. 입증된 실적을 가진 경험 많은 인사 전문가로서, 캐시 글래스는 우리의 프레임워크를 강화하고 회사 내 부서의 전략적 역할을 발전시키는 데 중요한 역할을 할 것입니다.

경영진은 캐시 글래스가 우리 조직의 성공을 이끌 귀중한 통찰력과 새로운 관점을 가져올 것이라고 믿습니다. 그녀의 주요 초점은 회사의 전반적인 사명과 비전에 부합하는 인사 전략을 개발하고 구현하는 것이 될 것입니다.

우리는 우리의 직원들에게 투자하고 육성하는 것을 믿기 때문에, 캐시 글래스가 상호 성장이라는 우리의 미덕에 기여하며 이 역할에 적합한 인재라고 확신합니다.

우리는 진심으로 캐시 글래스를 환영합니다. 그녀의 합류는 단순히 우리 회사 여정의 새로운 장이 아니라 성장과 진보를 알리는 중요한 이정표입니다.`,

  koreanNouns: `FOR IMMEDIATE RELEASE

LuminaCore Industries Welcomes New HR Leader

ARGYLE, TEXAS - January 1, 2060 - We are excited to announce a new addition to our team at LuminaCore Industries. A major step towards delivering on our promise of providing a better working environment and culture, Kathy Glass, an experienced Human Resources professional, has been hired as our new HR leader.

The new appointment reflects our commitment and vision toward establishing a new standard of excellence in the organization. As an experienced HR professional with a <mark>입증된</mark> track record, Kathy Glass will be <mark>중요한</mark> in <mark>강화하는것</mark> our framework and <mark>발전시키는것</mark> the department's strategic role within the company.

The management believes that Kathy Glass brings valuable insights and fresh <mark>관점</mark> that will drive our organization's success. Their primary focus will be developing and implementing HR strategies that align with the company's overall mission and vision.

We believe in investing in and <mark>육성하는</mark> our people, and hence, we're confident that Kathy Glass is the right fit for this role, contributing to our virtue of mutual growth.

We <mark>진심으로</mark> welcome Kathy Glass. Their addition is not just a new chapter in our company's journey but a significant milestone that signals growth and progress.`,

  wordPairs: {
    proven: "입증된",
    instrumental: "중요한",
    strengthening: "강화하는것",
    evolving: "발전시키는것",
    perspectives: "관점",
    nurturing: "육성하는",
    wholeheartedly: "진심으로",
  },

  questions: [],
};

const pressRelease4 = {
  id: 4,
  passage: `FOR IMMEDIATE RELEASE

Local Art Gallery Presents "Visions of the Future" – An Inspiring Art Exhibition

Raleigh, NC – NovaFrame Gallery is excited to announce its upcoming art exhibition, "Visions of the Future," featuring the innovative works of renowned local artist Jewell Ward. The exhibition will open on October 15, 2054, and run through November 30, 2054, at NovaFrame Gallery, located at 712 Waverly Street, Raleigh, NC 27601.

"Visions of the Future" showcases a diverse range of <mark>mediums</mark>, including paintings, sculptures, and mixed media, all <mark>reflecting</mark> Jewell Ward's unique perspective on the themes of technology, nature, and the human experience. With over 30 pieces on display, this exhibition invites <mark>viewers</mark> to explore the <mark>intersection</mark> of art and <mark>futurism</mark>, offering a thought-provoking <mark>glimpse</mark> into potential futures shaped by creativity and imagination.

Opening Reception

Join us for an opening reception on October 15, 2054, from 6:00 PM to 9:00 PM, where attendees will have the opportunity to meet the artist and enjoy live music, refreshments, and guided tours of the exhibition.

The exhibition is free and open to the public, with gallery hours from Tuesday to Sunday, 11:00 AM to 5:00 PM. For more information about the exhibition and upcoming events, please visit www.novaframegallery.org or contact Sabrina Miles at sabrina.miles@novaframegallery.org.`,

  translation: `즉시 보도용

지역 미술관, "미래의 비전" - 영감을 주는 미술 전시회 개최

노스캐롤라이나 롤리 - 노바프레임 갤러리는 저명한 지역 예술가 주얼 워드의 혁신적인 작품을 선보이는 미술 전시회 "미래의 비전"을 개최한다고 발표했습니다. 이 전시회는 2054년 10월 15일에 개막하여 2054년 11월 30일까지 노스캐롤라이나 롤리 웨이벌리 거리 712번지(우편번호 27601)에 위치한 노바프레임 갤러리에서 진행됩니다.

"미래의 비전"은 회화, 조각, 혼합 매체 등 다양한 매체를 선보이며, 모두 주얼 워드의 기술, 자연, 인간 경험이라는 주제에 대한 독특한 관점을 반영합니다. 30점 이상의 작품이 전시되는 이번 전시회는 관람객들에게 예술과 미래주의의 교차점을 탐색할 기회를 제공하며, 창의성과 상상력으로 형성된 잠재적 미래에 대한 생각을 자극하는 통찰을 제공합니다.

개막 리셉션

2054년 10월 15일 오후 6시부터 9시까지 열리는 개막 리셉션에 참석하시어 예술가를 만나고 라이브 음악, 다과, 그리고 전시회의 가이드 투어를 즐기시기 바랍니다.

이 전시회는 무료로 일반에 공개되며, 갤러리 운영 시간은 화요일부터 일요일까지 오전 11시부터 오후 5시까지입니다. 전시회 및 향후 이벤트에 대한 자세한 정보는 www.novaframegallery.org를 방문하거나 sabrina.miles@novaframegallery.org로 사브리나 마일스에게 문의하십시오.`,

  koreanNouns: `FOR IMMEDIATE RELEASE

Local Art Gallery Presents "Visions of the Future" – An Inspiring Art Exhibition

Raleigh, NC – NovaFrame Gallery is excited to announce its upcoming art exhibition, "Visions of the Future," featuring the innovative works of renowned local artist Jewell Ward. The exhibition will open on October 15, 2054, and run through November 30, 2054, at NovaFrame Gallery, located at 712 Waverly Street, Raleigh, NC 27601.

"Visions of the Future" showcases a diverse range of <mark>매체</mark>, including paintings, sculptures, and mixed media, all <mark>반영하는</mark> Jewell Ward's unique perspective on the themes of technology, nature, and the human experience. With over 30 pieces on display, this exhibition invites <mark>관람객들</mark> to explore the <mark>교차점</mark> of art and <mark>미래주의</mark>, offering a thought-provoking <mark>엿봄</mark> into potential futures shaped by creativity and imagination.

Opening Reception

Join us for an opening reception on October 15, 2054, from 6:00 PM to 9:00 PM, where attendees will have the opportunity to meet the artist and enjoy live music, refreshments, and guided tours of the exhibition.

The exhibition is free and open to the public, with gallery hours from Tuesday to Sunday, 11:00 AM to 5:00 PM. For more information about the exhibition and upcoming events, please visit www.novaframegallery.org or contact Sabrina Miles at sabrina.miles@novaframegallery.org.`,

  wordPairs: {
    mediums: "매체",
    reflecting: "반영하는",
    viewers: "관람객들",
    intersection: "교차점",
    futurism: "미래주의",
    glimpse: "엿봄",
  },

  questions: [],
};

const pressRelease5 = {
  id: 5,
  passage: `By: Elena Rivers

Aberdeen, South Dakota – January 1, 2060 – Music <mark>enthusiasts</mark> are set for an audio-visual treat as Elena Rivers announces the release of an innovative new music album, creatively <mark>curated</mark> to blend <mark>diverse</mark> sound waves into an enchanting harmonic experience. This key musical <mark>offering</mark> is sure to set a new standard in the global music industry.

<mark>Widely</mark> anticipating a positive response from the music community, Elena Rivers highlights the unique <mark>amalgamation</mark> of various tones and rhythms <mark>embedded</mark> into this album. The approach is to provide listeners with a <mark>captivating</mark> and distinct musical experience, thus expanding the <mark>boundaries</mark> of music.
"Our vision is to resonate with the audience on a deeper emotional level, <mark>weaving</mark> stories through powerful audio narratives," — Elena Rivers

In the heart of this press release, Elena Rivers <mark>urges</mark> music lovers, enthusiasts, and critics to explore this new addition to their discography. As an attempt to <mark>diversify</mark> the conventional music genre, the creator assures listeners of a thought-provoking, <mark>immersive</mark> musical journey.

For more information about the new music album, interviews, or promo requests, please contact Elena Rivers at elena.rivers.music@mail.com.`,

  translation: `작성자: 엘레나 리버스

사우스다코타 애버딘 – 2060년 1월 1일 – 음악 애호가들은 엘레나 리버스가 다양한 음파를 매혹적인 화음 경험으로 창의적으로 조합한 혁신적인 새 음악 앨범 출시를 발표함에 따라 시청각적 즐거움을 누릴 준비가 되었습니다. 이 중요한 음악 작품은 글로벌 음악 산업에 새로운 기준을 세울 것입니다.

음악 커뮤니티로부터 긍정적인 반응을 널리 기대하며, 엘레나 리버스는 이 앨범에 담긴 다양한 음색과 리듬의 독특한 융합을 강조합니다. 이 접근 방식은 청취자에게 매력적이고 독특한 음악 경험을 제공하여 음악의 경계를 확장하는 것입니다.
"우리의 비전은 강력한 오디오 내러티브를 통해 이야기를 엮어내며 더 깊은 감정적 수준에서 청중과 공감하는 것입니다," — 엘레나 리버스

이 보도 자료의 핵심에서, 엘레나 리버스는 음악 애호가, 열정가, 비평가들에게 그들의 음반 목록에 이 새로운 추가작을 탐색해 볼 것을 촉구합니다. 전통적인 음악 장르를 다양화하려는 시도로서, 창작자는 청취자들에게 생각을 자극하는 몰입형 음악 여행을 약속합니다.

새 음악 앨범, 인터뷰 또는 프로모션 요청에 대한 자세한 정보는 elena.rivers.music@mail.com으로 엘레나 리버스에게 문의하십시오.`,

  koreanNouns: `By: Elena Rivers

Aberdeen, South Dakota – January 1, 2060 – Music <mark>애호가들</mark> are set for an audio-visual treat as Elena Rivers announces the release of an innovative new music album, creatively <mark>엄선된</mark> to blend <mark>다양한</mark> sound waves into an enchanting harmonic experience. This key musical <mark>작품</mark> is sure to set a new standard in the global music industry.

<mark>널리</mark> anticipating a positive response from the music community, Elena Rivers highlights the unique <mark>융합</mark> of various tones and rhythms <mark>내장된</mark> into this album. The approach is to provide listeners with a <mark>매력적인</mark> and distinct musical experience, thus expanding the <mark>경계</mark> of music.
"Our vision is to resonate with the audience on a deeper emotional level, <mark>엮어내며</mark> stories through powerful audio narratives," — Elena Rivers

In the heart of this press release, Elena Rivers <mark>촉구합니다</mark> music lovers, enthusiasts, and critics to explore this new addition to their discography. As an attempt to <mark>다양화하려는</mark> the conventional music genre, the creator assures listeners of a thought-provoking, <mark>몰입형</mark> musical journey.

For more information about the new music album, interviews, or promo requests, please contact Elena Rivers at elena.rivers.music@mail.com.`,

  wordPairs: {
    enthusiasts: "애호가들",
    curated: "엄선된",
    diverse: "다양한",
    offering: "작품",
    Widely: "널리",
    amalgamation: "융합",
    embedded: "내장된",
    captivating: "매력적인",
    boundaries: "경계",
    weaving: "엮어내며",
    urges: "촉구합니다",
    diversify: "다양화하려는",
    immersive: "몰입형",
  },

  questions: [],
};

// ... existing code ...

const pressRelease6 = {
  id: 6,
  passage: `FOR IMMEDIATE RELEASE

UnitySports Foundation is excited to announce the Annual Charity Basketball Tournament, set to take place on November 15, 2054, at the Springfield Community Center. This event aims to <mark>raise</mark> funds to support local youth sports programs, ensuring that all children have the opportunity to participate in athletics.

"We are thrilled to bring the community together for a day of competition and fun," said Porter Hoppe, President of UnitySports Foundation.

"All <mark>proceeds</mark> from the event will directly support young athletes and help make sports more accessible for everyone."

The tournament will feature teams from Springfield High School, Lincoln Middle School, and local youth clubs, with games starting at 9:00 AM. In addition to basketball, there will be food vendors, raffles, and family-friendly activities throughout the day.`,

  translation: `즉시 보도용

유니티스포츠 재단은 2054년 11월 15일 스프링필드 커뮤니티 센터에서 개최될 연례 자선 농구 토너먼트를 발표하게 되어 기쁩니다. 이 행사는 지역 청소년 스포츠 프로그램을 지원하기 위한 기금을 모금하여 모든 어린이들이 체육 활동에 참여할 기회를 가질 수 있도록 하는 것을 목표로 합니다.

"우리는 경쟁과 재미가 있는 하루를 위해 지역사회를 한자리에 모을 수 있게 되어 매우 기쁩니다,"라고 유니티스포츠 재단의 회장인 포터 호프가 말했습니다.

"행사의 모든 수익금은 직접 젊은 운동선수들을 지원하고 모든 사람들이 스포츠에 더 쉽게 접근할 수 있도록 도울 것입니다."

이 토너먼트는 스프링필드 고등학교, 링컨 중학교, 그리고 지역 청소년 클럽 팀들이 참가하며, 경기는 오전 9시에 시작됩니다. 농구 외에도 하루 종일 음식 판매자, 경품 추첨, 그리고 가족 친화적인 활동들이 있을 예정입니다.`,

  koreanNouns: `FOR IMMEDIATE RELEASE

UnitySports Foundation is excited to announce the Annual Charity Basketball Tournament, set to take place on November 15, 2054, at the Springfield Community Center. This event aims to <mark>모금하기</mark> funds to support local youth sports programs, ensuring that all children have the opportunity to participate in athletics.

"We are thrilled to bring the community together for a day of competition and fun," said Porter Hoppe, President of UnitySports Foundation.

"All <mark>수익금</mark> from the event will directly support young athletes and help make sports more accessible for everyone."

The tournament will feature teams from Springfield High School, Lincoln Middle School, and local youth clubs, with games starting at 9:00 AM. In addition to basketball, there will be food vendors, raffles, and family-friendly activities throughout the day.`,

  wordPairs: {
    raise: "모금하기",
    proceeds: "수익금",
  },

  questions: [],
};

const pressRelease7 = {
  id: 7,
  passage: `FOR IMMEDIATE RELEASE

Moonlight Quill Publishing is excited to announce the release of "Whispers of the Forest," a <mark>captivating</mark> fantasy novel by Etha Lehner, hitting shelves on October 15, 2054. This <mark>enchanting</mark> tale explores the themes of friendship and <mark>courage</mark> in a world filled with magical <mark>creatures</mark> and ancient secrets.

In Whispers of the Forest, Etha Lehner takes us on a journey through the mystical Eldergrove Forest, where a young girl named Lila discovers her hidden powers and a destiny intertwined with an ancient <mark>prophecy</mark>. As she navigates challenges and <mark>forges</mark> unexpected <mark>alliances</mark>, Lila must <mark>confront</mark> dark forces that <mark>threaten</mark> her world.

"Every forest holds stories waiting to be <mark>uncovered</mark>, and I wanted to explore the magic hidden within those <mark>tales</mark>," says Etha Lehner.

Etha Lehner, known for her <mark>debut</mark> novel Shadows of the Past, brings her unique voice and storytelling ability to this new work. Readers can expect rich <mark>world-building</mark>, vivid character development, and a story that <mark>resonates</mark> with anyone who has ever <mark>dared</mark> to dream.

Whispers of the Forest will be available at all major bookstores, online retailers, and through the publisher's website www.moonlightquillbooks.com.`,

  translation: `즉시 보도용

문라이트 퀼 출판사는 2054년 10월 15일에 출시되는 에타 레너의 매력적인 판타지 소설 "숲의 속삭임"의 출간을 발표하게 되어 기쁩니다. 이 매혹적인 이야기는 마법 생물과 고대 비밀로 가득 찬 세계에서 우정과 용기의 주제를 탐구합니다.

"숲의 속삭임"에서 에타 레너는 우리를 신비로운 엘더그로브 숲으로 안내합니다. 이곳에서 릴라라는 어린 소녀가 자신의 숨겨진 능력과 고대 예언과 얽힌 운명을 발견합니다. 그녀가 도전을 헤쳐나가고 예상치 못한 동맹을 맺으면서, 릴라는 자신의 세계를 위협하는 어둠의 세력에 맞서야 합니다.

"모든 숲은 발견되기를 기다리는 이야기를 품고 있으며, 저는 그 이야기 속에 숨겨진 마법을 탐구하고 싶었습니다,"라고 에타 레너가 말합니다.

데뷔작 "과거의 그림자"로 알려진 에타 레너는 이 새로운 작품에 그녀만의 독특한 목소리와 스토리텔링 능력을 담아냈습니다. 독자들은 풍부한 세계관 구축, 생생한 캐릭터 발전, 그리고 꿈을 꾸어본 모든 이들에게 공감을 불러일으키는 이야기를 기대할 수 있습니다.

"숲의 속삭임"은 모든 주요 서점, 온라인 소매점, 그리고 출판사 웹사이트 www.moonlightquillbooks.com을 통해 구매하실 수 있습니다.`,

  koreanNouns: `FOR IMMEDIATE RELEASE

Moonlight Quill Publishing is excited to announce the release of "Whispers of the Forest," a <mark>매력적인</mark> fantasy novel by Etha Lehner, hitting shelves on October 15, 2054. This <mark>매혹적인</mark> tale explores the themes of friendship and <mark>용기</mark> in a world filled with magical <mark>생물</mark> and ancient secrets.

In Whispers of the Forest, Etha Lehner takes us on a journey through the mystical Eldergrove Forest, where a young girl named Lila discovers her hidden powers and a destiny intertwined with an ancient <mark>예언</mark>. As she navigates challenges and <mark>만들어내다</mark> unexpected <mark>동맹</mark>, Lila must <mark>직면하다</mark> dark forces that <mark>위협하는</mark> her world.

"Every forest holds stories waiting to be <mark>드러난</mark>, and I wanted to explore the magic hidden within those <mark>이야기</mark>," says Etha Lehner.

Etha Lehner, known for her <mark>데뷔작</mark> novel Shadows of the Past, brings her unique voice and storytelling ability to this new work. Readers can expect rich <mark>세계관 구축</mark>, vivid character development, and a story that <mark>공감을 불러일으키는</mark> with anyone who has ever <mark>꿈을 꾸어본</mark> to dream.

Whispers of the Forest will be available at all major bookstores, online retailers, and through the publisher's website www.moonlightquillbooks.com.`,

  wordPairs: {
    captivating: "매력적인",
    enchanting: "매혹적인",
    courage: "용기",
    creatures: "생물",
    prophecy: "예언",
    forges: "만들어내다",
    alliances: "동맹",
    confront: "직면하다",
    threaten: "위협하는",
    uncovered: "드러난",
    tales: "이야기",
    debut: "데뷔작",
    "world-building": "세계관 구축",
    resonates: "공감을 불러일으키는",
    dared: "꿈을 꾸어본",
  },

  questions: [],
};
const pressRelease8 = {
  id: 8,
  passage: `XYZ Corporation has announced the release of its much-anticipated product, marking a significant milestone in the brand's history. This launch <mark>reflects</mark> the corporation's <mark>commitment</mark> to innovation and sets a new standard in the market.

The release of the new product underscores XYZ Corporation's dedication to pushing the <mark>boundaries</mark> of technology and exploring new <mark>frontiers</mark>. With this launch, the company aims to <mark>strengthen</mark> its position as a leader in the industry.

"We are thrilled to bring this new product to market," <mark>remarked</mark> John Doe, CEO of XYZ Corporation. "Our team has worked <mark>tirelessly</mark> to ensure it meets the highest standards of quality and innovation."

The new product is designed to enhance the user experience and <mark>integrate</mark> seamlessly into everyday life. Its introduction is expected to <mark>revolutionize</mark> the market and provide consumers with <mark>unprecedented</mark> convenience and functionality.

XYZ Corporation is <mark>renowned</mark> for its cutting-edge solutions and customer-centric approach, and this <mark>latest</mark> <mark>offering</mark> is no exception. The product is now available for purchase, offering consumers a glimpse into the future of technology.`,

  translation: `XYZ 코퍼레이션이 오랫동안 기다려온 제품의 출시를 발표했으며, 이는 브랜드 역사에 중요한 이정표가 되고 있습니다. 이번 출시는 기업의 혁신에 대한 헌신을 반영하며 시장에 새로운 기준을 제시합니다.

새 제품의 출시는 XYZ 코퍼레이션이 기술의 경계를 넓히고 새로운 영역을 탐구하는 데 전념하고 있음을 강조합니다. 이번 출시를 통해 회사는 업계 리더로서의 입지를 강화하고자 합니다.

"우리는 이 새로운 제품을 시장에 선보이게 되어 매우 기쁩니다,"라고 XYZ 코퍼레이션의 CEO인 존 도우가 말했습니다. "우리 팀은 최고 품질과 혁신의 기준을 충족시키기 위해 쉬지 않고 노력했습니다."

새 제품은 사용자 경험을 향상시키고 일상생활에 원활하게 통합되도록 설계되었습니다. 이 제품의 도입은 시장에 혁명을 일으키고 소비자에게 전례 없는 편의성과 기능성을 제공할 것으로 예상됩니다.

XYZ 코퍼레이션은 최첨단 솔루션과 고객 중심 접근 방식으로 유명하며, 이번 최신 제품도 예외가 아닙니다. 이 제품은 현재 구매 가능하며, 소비자에게 기술의 미래를 엿볼 수 있는 기회를 제공합니다.`,

  koreanNouns: `XYZ Corporation has announced the release of its much-anticipated product, marking a significant milestone in the brand's history. This launch <mark>반영하다</mark> the corporation's <mark>헌신</mark> to innovation and sets a new standard in the market.

The release of the new product underscores XYZ Corporation's dedication to pushing the <mark>경계</mark> of technology and exploring new <mark>미개척분야</mark>. With this launch, the company aims to <mark>강화하다</mark> its position as a leader in the industry.

"We are thrilled to bring this new product to market," <mark>말했다</mark> John Doe, CEO of XYZ Corporation. "Our team has worked <mark>지치지않고</mark> to ensure it meets the highest standards of quality and innovation."

The new product is designed to enhance the user experience and <mark>통합하다</mark> seamlessly into everyday life. Its introduction is expected to <mark>혁명을 일으키다</mark> the market and provide consumers with <mark>전례 없는</mark> convenience and functionality.

XYZ Corporation is <mark>유명한</mark> for its cutting-edge solutions and customer-centric approach, and this <mark>최신</mark> <mark>제품</mark> is no exception. The product is now available for purchase, offering consumers a glimpse into the future of technology.`,
  wordPairs: {
    reflects: "반영하다",
    commitment: "헌신",
    boundaries: "경계",
    frontiers: "미개척분야",
    strengthen: "강화하다",
    remarked: "말했다",
    tirelessly: "지치지않고",
    integrate: "통합하다",
    revolutionize: "혁명을 일으키다",
    unprecedented: "전례 없는",
    renowned: "유명한",
    latest: "최신",
    offering: "제품",
  },

  questions: [],
};
const pressRelease9 = {
  id: 9,
  passage: `The National Design Museum has announced the opening of its highly anticipated exhibition, Design Futures: Shaping Tomorrow, <mark>set to</mark> <mark>captivate</mark> audiences with a fresh and <mark>forward-thinking approach</mark> to design and creativity.

This groundbreaking exhibition offers an innovative platform for designers, artists, and cultural enthusiasts, showcasing cutting-edge works that reflect the <mark>evolving</mark> relationship between design, technology, and society. More than just a display, the event is <mark>crafted</mark> to <mark>foster</mark> collaboration and spark inspiration among visitors and professionals alike.

Reflecting the museum's mission to present a dynamic <mark>interpretation</mark> of contemporary culture, Design Futures captures the pulse of today's design landscape. The exhibition highlights innovative materials, <mark>sustainable</mark> practices, and interactive experiences that <mark>redefine</mark> the boundaries of modern design.

The National Design Museum invites all to experience this <mark>transformative</mark> exhibition, which opens to the public on April 15 and runs through September 1. Visitors can expect an unforgettable journey through the possibilities of design in shaping the future.`,

  translation: `국립 디자인 박물관이 디자인 퓨처스: 내일을 형성하다(Design Futures: Shaping Tomorrow)라는 오랫동안 기대되어 온 전시회의 개막을 발표했으며, 이는 디자인과 창의성에 대한 신선하고 미래지향적인 접근 방식으로 관객들을 사로잡을 예정입니다.

이 획기적인 전시회는 디자이너, 예술가 및 문화 애호가들을 위한 혁신적인 플랫폼을 제공하며, 디자인, 기술 및 사회 간의 진화하는 관계를 반영하는 최첨단 작품들을 선보입니다. 단순한 전시를 넘어, 이 행사는 방문객과 전문가들 사이에 협력을 촉진하고 영감을 불러일으키도록 제작되었습니다.

현대 문화의 역동적인 해석을 제시하는 박물관의 사명을 반영하여, 디자인 퓨처스는 오늘날 디자인 풍경의 맥박을 포착합니다. 이 전시회는 현대 디자인의 경계를 재정의하는 혁신적인 재료, 지속 가능한 관행 및 상호작용 경험을 강조합니다.

국립 디자인 박물관은 4월 15일부터 9월 1일까지 일반에 공개되는 이 변혁적인 전시회를 경험하도록 모든 이들을 초대합니다. 방문객들은 미래를 형성하는 디자인의 가능성을 통한 잊을 수 없는 여정을 기대할 수 있습니다.`,

  koreanNouns: `The National Design Museum has announced the opening of its highly anticipated exhibition, Design Futures: Shaping Tomorrow, <mark>예정이다</mark> <mark>사로잡다</mark> audiences with a fresh and <mark>미래지향적인 접근 방식</mark> to design and creativity.

This groundbreaking exhibition offers an innovative platform for designers, artists, and cultural enthusiasts, showcasing cutting-edge works that reflect the <mark>진화하는</mark> relationship between design, technology, and society. More than just a display, the event is <mark>제작되다</mark> to <mark>촉진하다</mark> collaboration and spark inspiration among visitors and professionals alike.

Reflecting the museum's mission to present a dynamic <mark>해석</mark> of contemporary culture, Design Futures captures the pulse of today's design landscape. The exhibition highlights innovative materials, <mark>지속 가능한</mark> practices, and interactive experiences that <mark>재정의하다</mark> the boundaries of modern design.

The National Design Museum invites all to experience this <mark>변혁적인</mark> exhibition, which opens to the public on April 15 and runs through September 1. Visitors can expect an unforgettable journey through the possibilities of design in shaping the future.`,
  wordPairs: {
    "set to": "예정이다",
    captivate: "사로잡다",
    "forward-thinking approach": "미래지향적인 접근 방식",
    evolving: "진화하는",
    foster: "촉진하다",
    crafted: "제작되다",
    interpretation: "해석",
    sustainable: "지속 가능한",
    redefine: "재정의하다",
    transformative: "변혁적인",
  },

  questions: [],
};
const pressRelease10 = {
  id: 10,
  passage: `Exciting Exhibition Announcement Heralds New Era for Industry Enthusiasts

An exceptional exhibition is set to unveil itself, promising an innovative platform for industry professionals and enthusiasts alike. This event is designed not only to showcase cutting-edge advancements but also to <mark>foster</mark> a remarkable blend of collaboration and inspiration within the community.

Participants will have the unique opportunity to engage with <mark>pioneering</mark> companies and <mark>visionaries</mark> who are at the <mark>forefront</mark> of innovation. The event will serve as a <mark>catalyst</mark> for creativity, providing attendees with a dynamic environment to exchange ideas, explore new trends, and establish valuable connections.

The exhibition aims to capture the <mark>essence</mark> of the industry's evolving landscape, offering an <mark>integrated</mark> approach that <mark>underscores</mark> the <mark>distinctive</mark> identity of the brand. Visitors can anticipate a <mark>vibrant</mark> atmosphere where the latest technologies and <mark>methodologies</mark> will be on full display, offering insights into the future of the industry.

With a focus on generating meaningful interactions, the event is <mark>poised</mark> to become a landmark occasion in the industry calendar. As anticipation builds, attendees are encouraged to prepare for an <mark>immersive</mark> experience that promises to redefine standards and perceptions across the sector.`,

  translation: `흥미진진한 전시회 발표, 산업 애호가들을 위한 새로운 시대를 알리다

특별한 전시회가 공개될 예정이며, 산업 전문가와 애호가 모두에게 혁신적인 플랫폼을 약속합니다. 이 행사는 최첨단 발전을 선보일 뿐만 아니라 커뮤니티 내에서 협업과 영감의 놀라운 조화를 촉진하도록 설계되었습니다.

참가자들은 혁신의 최전선에 있는 선구적인 기업들과 비전을 가진 사람들과 교류할 수 있는 독특한 기회를 갖게 될 것입니다. 이 행사는 창의성의 촉매제 역할을 하며, 참석자들에게 아이디어를 교환하고, 새로운 트렌드를 탐색하며, 가치 있는 연결을 구축할 수 있는 역동적인 환경을 제공합니다.

이 전시회는 브랜드의 독특한 정체성을 강조하는 통합적 접근 방식을 제공하며, 산업의 진화하는 풍경의 본질을 포착하는 것을 목표로 합니다. 방문객들은 최신 기술과 방법론이 완벽하게 전시되는 활기찬 분위기를 기대할 수 있으며, 산업의 미래에 대한 통찰력을 제공합니다.

의미 있는 상호작용 생성에 중점을 두고, 이 행사는 산업 일정에서 획기적인 행사가 될 것으로 예상됩니다. 기대감이 고조됨에 따라, 참석자들은 업계 전반의 표준과 인식을 재정의할 것을 약속하는 몰입형 경험을 준비하도록 권장됩니다.`,

  koreanNouns: `Exciting Exhibition Announcement Heralds New Era for Industry Enthusiasts

An exceptional exhibition is set to unveil itself, promising an innovative platform for industry professionals and enthusiasts alike. This event is designed not only to showcase cutting-edge advancements but also to <mark>촉진하다</mark> a remarkable blend of collaboration and inspiration within the community.

Participants will have the unique opportunity to engage with <mark>선구적인</mark> companies and <mark>비전을 가진 사람들</mark> who are at the <mark>최전선</mark> of innovation. The event will serve as a <mark>촉매제</mark> for creativity, providing attendees with a dynamic environment to exchange ideas, explore new trends, and establish valuable connections.

The exhibition aims to capture the <mark>본질</mark> of the industry's evolving landscape, offering an <mark>통합적인</mark> approach that <mark>강조하다</mark> the <mark>독특한</mark> identity of the brand. Visitors can anticipate a <mark>활기찬</mark> atmosphere where the latest technologies and <mark>방법론</mark> will be on full display, offering insights into the future of the industry.

With a focus on generating meaningful interactions, the event is <mark>준비된</mark> to become a landmark occasion in the industry calendar. As anticipation builds, attendees are encouraged to prepare for an <mark>몰입형</mark> experience that promises to redefine standards and perceptions across the sector.`,
  wordPairs: {
    foster: "촉진하다",
    pioneering: "선구적인",
    visionaries: "비전을 가진 사람들",
    forefront: "최전선",
    catalyst: "촉매제",
    essence: "본질",
    integrated: "통합적인",
    underscores: "강조하다",
    distinctive: "독특한",
    vibrant: "활기찬",
    methodologies: "방법론",
    poised: "준비된",
    immersive: "몰입형",
  },

  questions: [],
};
const pressRelease11 = {
  id: 11,
  passage: `Contemporary Art Exhibition Showcases Innovative Artistic Expression

We are proud to present the upcoming Contemporary Art Exhibition, a unique exploration into the evolving landscape of modern artistic expression. This event will take place from November 10th to December 15th, 2023, at the prestigious Art Haven Gallery. Visitors will experience an extraordinary collection of thought-provoking artworks, each piece <mark>echoing</mark> the innovative voices of today's most <mark>daring</mark> artists.

This exhibition represents a <mark>bold</mark> <mark>intersection</mark> of creativity and identity, providing a platform where artists can showcase their diverse perspectives through various mediums. Sculptures, paintings, digital installations, and multimedia performances will be featured, offering visitors an immersive experience that challenges conventional boundaries.

The Contemporary Art Exhibition promises to be a groundbreaking event that not only celebrates artistic achievement but also engages with the critical discourse surrounding the influence of modern art on society. Through this <mark>integrated</mark> approach, we aim to create a <mark>compelling</mark> narrative that enhances and <mark>embodies</mark> the brand's unique identity, <mark>inviting</mark> art enthusiasts and <mark>newcomers</mark> <mark>alike</mark> to discover the <mark>transformative</mark> power of contemporary artistry.`,

  translation: `현대 미술 전시회, 혁신적인 예술적 표현 선보여

다가오는 현대 미술 전시회를 자랑스럽게 소개합니다. 이 전시회는 현대 예술적 표현의 진화하는 풍경을 독특하게 탐구합니다. 이 행사는 2023년 11월 10일부터 12월 15일까지 명망 있는 아트 헤이븐 갤러리에서 개최됩니다. 방문객들은 오늘날 가장 대담한 예술가들의 혁신적인 목소리를 반영하는 생각을 자극하는 예술 작품의 특별한 컬렉션을 경험하게 될 것입니다.

이 전시회는 창의성과 정체성의 대담한 교차점을 나타내며, 예술가들이 다양한 매체를 통해 자신의 다양한 관점을 선보일 수 있는 플랫폼을 제공합니다. 조각, 회화, 디지털 설치물, 멀티미디어 공연이 선보여지며, 방문객들에게 기존의 경계에 도전하는 몰입형 경험을 제공합니다.

현대 미술 전시회는 예술적 성취를 축하할 뿐만 아니라 현대 예술이 사회에 미치는 영향에 관한 중요한 담론에 참여하는 획기적인 행사가 될 것을 약속합니다. 이러한 통합적 접근 방식을 통해, 우리는 브랜드의 독특한 정체성을 강화하고 구현하는 매력적인 내러티브를 만들고자 합니다. 이를 통해 예술 애호가와 초보자 모두가 현대 예술의 변혁적인 힘을 발견하도록 초대합니다.`,

  koreanNouns: `Contemporary Art Exhibition Showcases Innovative Artistic Expression

We are proud to present the upcoming Contemporary Art Exhibition, a unique exploration into the evolving landscape of modern artistic expression. This event will take place from November 10th to December 15th, 2023, at the prestigious Art Haven Gallery. Visitors will experience an extraordinary collection of thought-provoking artworks, each piece <mark>반영하는</mark> the innovative voices of today's most <mark>대담한</mark> artists.

This exhibition represents a <mark>대담한</mark> <mark>교차점</mark> of creativity and identity, providing a platform where artists can showcase their diverse perspectives through various mediums. Sculptures, paintings, digital installations, and multimedia performances will be featured, offering visitors an immersive experience that challenges conventional boundaries.

The Contemporary Art Exhibition promises to be a groundbreaking event that not only celebrates artistic achievement but also engages with the critical discourse surrounding the influence of modern art on society. Through this <mark>통합적인</mark> approach, we aim to create a <mark>매력적인</mark> narrative that enhances and <mark>구현하다</mark> the brand's unique identity, <mark>끌어당기는</mark> art enthusiasts and <mark>초보자</mark> <mark>똑같이 모두</mark> to discover the <mark>변혁적인</mark> power of contemporary artistry.`,
  wordPairs: {
    echoing: "반영하는",
    daring: "대담한",
    bold: "대담한",
    intersection: "교차점",
    integrated: "통합적인",
    compelling: "매력적인",
    embodies: "구현하다",
    inviting: "끌어당기는",
    newcomers: "초보자",
    alike: "똑같이 모두",
    transformative: "변혁적인",
  },

  questions: [],
};

const pressRelease12 = {
  id: 12,
  passage: `GreenCity Waste Management Announces Changes to Recycling Policy

GreenCity Waste Management has announced updates to its citywide recycling policy, effective starting April 1, 2025. The changes aim to <mark>streamline</mark> the recycling process and reduce <mark>contamination</mark> in recycling bins.

Under the revised guidelines, residents are now required to separate <mark>recyclables</mark> into three distinct categories: paper products, plastics and metals, and glass. Mixed <mark>recyclables</mark> in a single bin will no longer be accepted. In addition, all containers must be rinsed and free of food <mark>residue</mark> before being placed in the <mark>designated</mark> bins.

"We are committed to creating a cleaner, more sustainable community," said Angela Park, Director of Public Relations at GreenCity Waste Management. "These changes will help improve the efficiency of recycling operations and ensure that more materials are <mark>properly</mark> processed."

Informational <mark>flyers</mark> and updated recycling bin labels will be distributed to all <mark>households</mark> later this month. Residents are encouraged to visit the official GreenCity website or contact the customer service line for more information regarding the new policy.

GreenCity Waste Management appreciates the continued cooperation of its residents in supporting environmentally responsible practices.`,

  translation: `그린시티 폐기물 관리, 재활용 정책 변경 발표

그린시티 폐기물 관리는 2025년 4월 1일부터 시행되는 도시 전체 재활용 정책 업데이트를 발표했습니다. 이번 변경은 재활용 과정을 간소화하고 재활용 쓰레기통의 오염을 줄이는 것을 목표로 합니다.

개정된 지침에 따라, 주민들은 이제 재활용품을 종이 제품, 플라스틱 및 금속, 유리의 세 가지 뚜렷한 카테고리로 분리해야 합니다. 단일 쓰레기통에 혼합된 재활용품은 더 이상 수거되지 않습니다. 또한, 모든 용기는 지정된 쓰레기통에 넣기 전에 헹구고 음식물 잔여물이 없어야 합니다.

"우리는 더 깨끗하고 지속 가능한 커뮤니티를 만들기 위해 노력하고 있습니다,"라고 그린시티 폐기물 관리의 홍보 이사인 안젤라 박이 말했습니다. "이러한 변화는 재활용 작업의 효율성을 향상시키고 더 많은 재료가 적절히 처리되도록 보장할 것입니다."

정보 전단지와 업데이트된 재활용 쓰레기통 라벨이 이번 달 말에 모든 가정에 배포될 예정입니다. 주민들은 새로운 정책에 관한 자세한 정보를 위해 그린시티 공식 웹사이트를 방문하거나 고객 서비스 라인에 문의하는 것이 권장됩니다.

그린시티 폐기물 관리는 환경적으로 책임 있는 관행을 지원하는 주민들의 지속적인 협조에 감사드립니다.`,

  koreanNouns: `GreenCity Waste Management Announces Changes to Recycling Policy

GreenCity Waste Management has announced updates to its citywide recycling policy, effective starting April 1, 2025. The changes aim to <mark>간소화하다</mark> the recycling process and reduce <mark>오염</mark> in recycling bins.

Under the revised guidelines, residents are now required to separate <mark>재활용품</mark> into three distinct categories: paper products, plastics and metals, and glass. Mixed <mark>재활용품</mark> in a single bin will no longer be accepted. In addition, all containers must be rinsed and free of food <mark>잔여물</mark> before being placed in the <mark>지정된</mark> bins.

"We are committed to creating a cleaner, more sustainable community," said Angela Park, Director of Public Relations at GreenCity Waste Management. "These changes will help improve the efficiency of recycling operations and ensure that more materials are <mark>적절히</mark> processed."

Informational <mark>전단지</mark> and updated recycling bin labels will be distributed to all <mark>가정</mark> later this month. Residents are encouraged to visit the official GreenCity website or contact the customer service line for more information regarding the new policy.

GreenCity Waste Management appreciates the continued cooperation of its residents in supporting environmentally responsible practices.`,

  wordPairs: {
    streamline: "간소화하다",
    contamination: "오염",
    recyclables: "재활용품",
    residue: "잔여물",
    designated: "지정된",
    properly: "적절히",
    flyers: "전단지",
    households: "가정",
  },

  questions: [],
};
const pressRelease13 = {
  id: 13,
  passage: `MetroTransit Issues Service Changes Due to Road Construction

MetroTransit has announced temporary changes to several bus routes and schedules due to ongoing road construction in the <mark>downtown</mark> area. These changes will take effect beginning March 28, 2025, and are expected to remain in place through May 15, 2025.

During this period, Routes 12, 24, and 37 will be <mark>detoured</mark> to avoid Main Street between 3rd Avenue and 7th Avenue. Several bus stops along this stretch will be temporarily closed, and riders are advised to use <mark>alternate</mark> stops on Pine Street or Elm Street. Updated route maps and timetables are available on the MetroTransit website.

"We understand that changes in service can be inconvenient," said Carl Benson, Director of Transit Operations. "However, these adjustments are necessary to ensure safety while construction is underway. We appreciate our riders' patience and understanding."

Passengers are encouraged to plan ahead and allow for extra travel time during this period. For real-time updates and assistance, riders can download the MetroTransit mobile app or call the customer service hotline at (555) 014-8989.`,

  translation: `메트로트랜짓, 도로 공사로 인한 서비스 변경 발표

메트로트랜짓은 도심 지역의 진행 중인 도로 공사로 인해 여러 버스 노선과 일정에 임시 변경 사항을 발표했습니다. 이러한 변경은 2025년 3월 28일부터 시행되며, 2025년 5월 15일까지 유지될 것으로 예상됩니다.

이 기간 동안, 12번, 24번, 37번 노선은 3번 애비뉴와 7번 애비뉴 사이의 메인 스트리트를 피하기 위해 우회할 예정입니다. 이 구간을 따라 있는 여러 버스 정류장이 일시적으로 폐쇄되며, 승객들은 파인 스트리트나 엘름 스트리트의 대체 정류장을 이용하도록 권고됩니다. 업데이트된 노선 지도와 시간표는 메트로트랜짓 웹사이트에서 확인할 수 있습니다.

"서비스 변경이 불편할 수 있다는 점을 이해합니다,"라고 메트로트랜짓의 운영 이사인 칼 벤슨이 말했습니다. "하지만, 이러한 조정은 공사가 진행되는 동안 안전을 보장하기 위해 필요합니다. 승객 여러분의 인내와 이해에 감사드립니다."

승객들은 이 기간 동안 미리 계획하고 추가 이동 시간을 확보하는 것이 권장됩니다. 실시간 업데이트와 지원을 위해 승객들은 메트로트랜짓 모바일 앱을 다운로드하거나 고객 서비스 핫라인 (555) 014-8989로 전화할 수 있습니다.`,
  koreanNouns: `MetroTransit Issues Service Changes Due to Road Construction

MetroTransit has announced temporary changes to several bus routes and schedules due to ongoing road construction in the <mark>도심</mark> area. These changes will take effect beginning March 28, 2025, and are expected to remain in place through May 15, 2025.

During this period, Routes 12, 24, and 37 will be <mark>우회 되다</mark> to avoid Main Street between 3rd Avenue and 7th Avenue. Several bus stops along this stretch will be temporarily closed, and riders are advised to use <mark>대체</mark> stops on Pine Street or Elm Street. Updated route maps and timetables are available on the MetroTransit website.

"We understand that changes in service can be inconvenient," said Carl Benson, Director of Transit Operations. "However, these adjustments are necessary to ensure safety while construction is underway. We appreciate our riders' patience and understanding."

Passengers are encouraged to plan ahead and allow for extra travel time during this period. For real-time updates and assistance, riders can download the MetroTransit mobile app or call the customer service hotline at (555) 014-8989.`,

  wordPairs: {
    downtown: "도심",
    detoured: "우회 되다",
    alternate: "대체",
  },

  questions: [],
};
const pressRelease14 = {
  id: 14,
  passage: `Free Health Screening Event Offered by City Health Center

The Midtown City Health Center will host a Free Community Health Screening Event on Saturday, April 20, 2025, from 9:00 A.M. to 2:00 P.M. at the Midtown Community Hall. The event is open to all residents and aims to promote <mark>preventive</mark> care and overall wellness.

Attendees will receive free screenings for blood pressure, blood sugar, cholesterol, and body mass index (BMI). Licensed medical professionals will be <mark>on-site</mark> to provide basic health consultations and answer questions about healthy living.

"No registration is required," said Dr. Helen Moore, Director of Midtown City Health Center. "We encourage everyone, especially those who have limited access to healthcare, to take advantage of this opportunity."

The first 200 participants will also receive a free wellness kit, and informational brochures on diet, exercise, and mental health resources will be available at the venue.

For more information, residents can call (555) 983-2211 or visit the Midtown City Health Center's official website.`,

  translation: `시 보건 센터에서 제공하는 무료 건강 검진 행사

미드타운 시 보건 센터는 2025년 4월 20일 토요일 오전 9시부터 오후 2시까지 미드타운 커뮤니티 홀에서 무료 커뮤니티 건강 검진 행사를 개최합니다. 이 행사는 모든 주민들에게 열려 있으며 예방적 치료와 전반적인 웰빙을 증진하는 것을 목표로 합니다.

참석자들은 혈압, 혈당, 콜레스테롤 및 체질량 지수(BMI)에 대한 무료 검진을 받게 됩니다. 면허를 가진 의료 전문가들이 현장에서 기본적인 건강 상담을 제공하고 건강한 생활에 관한 질문에 답변할 예정입니다.

"등록이 필요하지 않습니다,"라고 미드타운 시 보건 센터의 디렉터인 헬렌 무어 박사가 말했습니다. "특히 의료 서비스에 대한 접근이 제한적인 분들을 포함하여 모든 분들이 이 기회를 활용하시길 권장합니다."

첫 200명의 참가자들은 무료 웰니스 키트도 받게 되며, 식이요법, 운동 및 정신 건강 자원에 관한 정보 브로셔가 행사장에서 제공될 예정입니다.

자세한 정보를 원하시는 주민들은 (555) 983-2211로 전화하거나 미드타운 시 보건 센터의 공식 웹사이트를 방문하시기 바랍니다.`,
  koreanNouns: `Free Health Screening Event Offered by City Health Center

The Midtown City Health Center will host a Free Community Health Screening Event on Saturday, April 20, 2025, from 9:00 A.M. to 2:00 P.M. at the Midtown Community Hall. The event is open to all residents and aims to promote <mark>예방적</mark> care and overall wellness.

Attendees will receive free screenings for blood pressure, blood sugar, cholesterol, and body mass index (BMI). Licensed medical professionals will be <mark>현장</mark> to provide basic health consultations and answer questions about healthy living.

"No registration is required," said Dr. Helen Moore, Director of Midtown City Health Center. "We encourage everyone, especially those who have limited access to healthcare, to take advantage of this opportunity."

The first 200 participants will also receive a free wellness kit, and informational brochures on diet, exercise, and mental health resources will be available at the venue.

For more information, residents can call (555) 983-2211 or visit the Midtown City Health Center's official website.`,

  wordPairs: {
    preventive: "예방적",
    "on-site": "현장",
  },

  questions: [],
};
const pressRelease15 = {
  id: 15,
  passage: `BrightMart Announces Price Adjustments on Select Products

BrightMart, a leading <mark>national</mark> <mark>retail</mark> chain, has announced that price adjustments will take effect beginning April 1, 2025, on a range of <mark>household</mark> and <mark>grocery</mark> items. The company <mark>cited</mark> increased transportation and <mark>raw material</mark> costs as key reasons for the changes.

Affected items include paper goods, dairy products, and cleaning supplies. On average, prices will increase by 3 to 5 percent. However, the company emphasized that many essential items will remain at current prices, and seasonal discounts will continue as planned.

"We remain committed to offering quality products at competitive prices," said Jenna Lee, BrightMart's Senior Pricing Manager. "While some adjustments are necessary, we are working hard to minimize the impact on our customers."

Customers are encouraged to check weekly flyers and the BrightMart mobile app for updated prices and ongoing promotions.`,

  translation: `브라이트마트, 일부 제품에 대한 가격 조정 발표

선도적인 전국 소매 체인인 브라이트마트는 2025년 4월 1일부터 가정용품 및 식료품 범위에 대한 가격 조정이 시작된다고 발표했습니다. 회사는 운송비 및 원자재 비용 증가를 변경의 주요 이유로 언급했습니다.

영향을 받는 품목에는 종이 제품, 유제품 및 청소용품이 포함됩니다. 평균적으로 가격은 3~5% 인상될 예정입니다. 그러나 회사는 많은 필수 품목들이 현재 가격을 유지할 것이며, 계절별 할인도 계획대로 계속될 것이라고 강조했습니다.

"우리는 경쟁력 있는 가격에 품질 좋은 제품을 제공하는 데 계속 전념하고 있습니다,"라고 브라이트마트의 수석 가격 관리자인 제나 리가 말했습니다. "일부 조정이 필요하지만, 우리는 고객에게 미치는 영향을 최소화하기 위해 열심히 노력하고 있습니다."

고객들은 업데이트된 가격과 진행 중인 프로모션을 확인하기 위해 주간 전단지와 브라이트마트 모바일 앱을 확인하는 것이 권장됩니다.`,
  koreanNouns: `BrightMart Announces Price Adjustments on Select Products

BrightMart, a leading <mark>전국</mark> <mark>소매</mark> chain, has announced that price adjustments will take effect beginning April 1, 2025, on a range of <mark>가정용품</mark> and <mark>식료품</mark> items. The company <mark>언급했습니다</mark> increased transportation and <mark>원자재</mark> costs as key reasons for the changes.

Affected items include paper goods, dairy products, and cleaning supplies. On average, prices will increase by 3 to 5 percent. However, the company emphasized that many essential items will remain at current prices, and seasonal discounts will continue as planned.

"We remain committed to offering quality products at competitive prices," said Jenna Lee, BrightMart's Senior Pricing Manager. "While some adjustments are necessary, we are working hard to minimize the impact on our customers."

Customers are encouraged to check weekly flyers and the BrightMart mobile app for updated prices and ongoing promotions.`,

  wordPairs: {
    national: "전국",
    retail: "소매",
    household: "가정용품",
    grocery: "식료품",
    cited: "언급했습니다",
    "raw material": "원자재",
  },

  questions: [],
};

const pressRelease16 = {
  id: 16,
  passage: `TechCorp Acquires Innovate Solutions to Expand AI Capabilities
Source: Business Weekly
Date: April 15, 2025

TechCorp, a leading technology firm, has announced its <mark>acquisition</mark> of Innovate Solutions, a company specializing in artificial intelligence and automation. The deal, valued at $850 million, is expected to <mark>strengthen</mark> TechCorp's AI-driven product line and expand its <mark>presence</mark> in global markets.

According to company officials, the <mark>acquisition</mark> will allow TechCorp to <mark>integrate</mark> Innovate Solutions' cutting-edge machine learning algorithms into its existing platforms. "This strategic move positions us at the <mark>forefront</mark> of AI innovation," said TechCorp CEO Jonathan Pierce. "By combining our expertise, we aim to deliver smarter and more efficient solutions for businesses worldwide."

Founded in 2008, Innovate Solutions has developed AI applications used in industries such as finance, healthcare, and logistics. Its flagship product, InnoBot, an AI-powered virtual assistant, has gained widespread adoption among enterprise clients. TechCorp officials have confirmed that the Innovate Solutions brand will remain <mark>intact</mark>, with its headquarters continuing operations in San Francisco.

The acquisition follows TechCorp's recent expansion efforts, including a $300 million investment in cloud computing infrastructure. Industry analysts predict that this <mark>latest</mark> move will enhance TechCorp's ability to compete with major AI companies.

More details about the acquisition will be revealed at the upcoming TechCorp Annual Conference, scheduled for May 20, 2025, in New York City.`,

  translation: `테크코프, AI 역량 확대를 위해 이노베이트 솔루션즈 인수
출처: 비즈니스 위클리
날짜: 2025년 4월 15일

선도적인 기술 기업인 테크코프가 인공지능과 자동화 분야의 전문 기업인 이노베이트 솔루션즈의 인수를 발표했습니다. 8억 5천만 달러 규모의 이번 거래는 테크코프의 AI 기반 제품 라인을 강화하고 글로벌 시장에서의 입지를 확대할 것으로 예상됩니다.

According to company officials, the acquisition will allow TechCorp to integrate Innovate Solutions' cutting-edge machine learning algorithms into its existing platforms. "This strategic move positions us at the forefront of AI innovation," said TechCorp CEO Jonathan Pierce. "By combining our expertise, we aim to deliver smarter and more efficient solutions for businesses worldwide."

Founded in 2008, Innovate Solutions has developed AI applications used in industries such as finance, healthcare, and logistics. Its flagship product, InnoBot, an AI-powered virtual assistant, has gained widespread adoption among enterprise clients. TechCorp officials have confirmed that the Innovate Solutions brand will remain intact, with its headquarters continuing operations in San Francisco.

The acquisition follows TechCorp's recent expansion efforts, including a $300 million investment in cloud computing infrastructure. Industry analysts predict that this latest move will enhance TechCorp's ability to compete with major AI companies.

More details about the acquisition will be revealed at the upcoming TechCorp Annual Conference, scheduled for May 20, 2025, in New York City.`,
  koreanNouns: `TechCorp Acquires Innovate Solutions to Expand AI Capabilities
Source: Business Weekly
Date: April 15, 2025

TechCorp, a leading technology firm, has announced its <mark>인수</mark> of Innovate Solutions, a company specializing in artificial intelligence and automation. The deal, valued at $850 million, is expected to <mark>강화하다</mark> TechCorp's AI-driven product line and expand its <mark>입지</mark> in global markets.

According to company officials, the <mark>인수</mark> will allow TechCorp to <mark>통합하다</mark> Innovate Solutions' cutting-edge machine learning algorithms into its existing platforms. "This strategic move positions us at the <mark>최전선</mark> of AI innovation," said TechCorp CEO Jonathan Pierce. "By combining our expertise, we aim to deliver smarter and more efficient solutions for businesses worldwide."

Founded in 2008, Innovate Solutions has developed AI applications used in industries such as finance, healthcare, and logistics. Its flagship product, InnoBot, an AI-powered virtual assistant, has gained widespread adoption among enterprise clients. TechCorp officials have confirmed that the Innovate Solutions brand will remain <mark>온전한</mark>, with its headquarters continuing operations in San Francisco.

The acquisition follows TechCorp's recent expansion efforts, including a $300 million investment in cloud computing infrastructure. Industry analysts predict that this <mark>최신의</mark> move will enhance TechCorp's ability to compete with major AI companies.

More details about the acquisition will be revealed at the upcoming TechCorp Annual Conference, scheduled for May 20, 2025, in New York City.`,

  wordPairs: {
    acquisition: "인수",
    strengthen: "강화하다",
    presence: "입지",
    integrate: "통합하다",
    forefront: "최전선",
    intact: "온전한",
    latest: "최신의",
  },

  questions: [],
};
const pressRelease17 = {
  id: 17,
  passage: `SmartTech Unveils Next-Generation Smartwatch, VisionX Pro
Source: Business Daily News
Date: June 5, 2025

SmartTech, a leading innovator in wearable technology, has officially announced the launch of its latest smartwatch, the VisionX Pro. The device, which features advanced health tracking and AI-driven functionality, is expected to <mark>redefine</mark> the smart wearables market.

The VisionX Pro boasts a high-resolution AMOLED display, an extended battery life of up to 10 days, and real-time health monitoring capabilities, including ECG tracking and oxygen saturation measurement. The smartwatch is also equipped with voice-activated AI assistance, enabling users to manage schedules, send messages, and control smart home devices <mark>effortlessly</mark>.

"Our goal is to provide a <mark>seamless</mark> blend of technology and daily life," said Michael Grant, CEO of SmartTech. "The VisionX Pro is not just a smartwatch; it's an intelligent companion that enhances productivity and wellness."

The device will be available for pre-order starting June 10, 2025, with an <mark>official retail release</mark> on June 25, 2025. Customers who pre-order will receive an <mark>exclusive</mark> wireless charging dock and a three-month premium subscription to SmartTech Health+.

Industry analysts anticipate that the VisionX Pro will strengthen SmartTech's position in the competitive wearables market, particularly against established brands.`,

  translation: `스마트테크, 차세대 스마트워치 비전X 프로 공개
출처: 비즈니스 데일리 뉴스
날짜: 2025년 6월 5일

웨어러블 기술 분야의 선도적 혁신기업인 스마트테크가 최신 스마트워치인 비전X 프로의 출시를 공식 발표했습니다. 고급 건강 추적 기능과 AI 기반 기능을 갖춘 이 기기는 스마트 웨어러블 시장에 새로운 기준을 제시할 것으로 예상됩니다.

비전X 프로는 고해상도 AMOLED 디스플레이, 최대 10일의 연장된 배터리 수명, 심전도 추적과 산소포화도 측정을 포함한 실시간 건강 모니터링 기능을 자랑합니다. 이 스마트워치는 또한 음성 활성화 AI 지원 기능을 탑재하여 사용자가 일정 관리, 메시지 전송, 스마트홈 기기 제어를 손쉽게 할 수 있습니다.

"Our goal is to provide a seamless blend of technology and daily life," said Michael Grant, CEO of SmartTech. "The VisionX Pro is not just a smartwatch; it's an intelligent companion that enhances productivity and wellness."

The device will be available for pre-order starting June 10, 2025, with an official retail release on June 25, 2025. Customers who pre-order will receive an exclusive wireless charging dock and a three-month premium subscription to SmartTech Health+.

Industry analysts anticipate that the VisionX Pro will strengthen SmartTech's position in the competitive wearables market, particularly against established brands.`,
  koreanNouns: `SmartTech Unveils Next-Generation Smartwatch, VisionX Pro
Source: Business Daily News
Date: June 5, 2025

SmartTech, a leading innovator in wearable technology, has officially announced the launch of its latest smartwatch, the VisionX Pro. The device, which features advanced health tracking and AI-driven functionality, is expected to <mark>새로운 기준을 제시하다</mark> the smart wearables market.

The VisionX Pro boasts a high-resolution AMOLED display, an extended battery life of up to 10 days, and real-time health monitoring capabilities, including ECG tracking and oxygen saturation measurement. The smartwatch is also equipped with voice-activated AI assistance, enabling users to manage schedules, send messages, and control smart home devices <mark>손쉽게</mark>.

"Our goal is to provide a <mark>원활한</mark> blend of technology and daily life," said Michael Grant, CEO of SmartTech. "The VisionX Pro is not just a smartwatch; it's an intelligent companion that enhances productivity and wellness."

The device will be available for pre-order starting June 10, 2025, with an <mark>공식 소매 출시</mark> on June 25, 2025. Customers who pre-order will receive an <mark>독점적인</mark> wireless charging dock and a three-month premium subscription to SmartTech Health+.

Industry analysts anticipate that the VisionX Pro will strengthen SmartTech's position in the competitive wearables market, particularly against established brands.`,

  wordPairs: {
    redefine: "새로운 기준을 제시하다",
    effortlessly: "손쉽게",
    seamless: "원활한",
    "official retail release": "공식 소매 출시",
    exclusive: "독점적인",
  },

  questions: [],
};

const pressRelease18 = {
  id: 3,
  passage: `GreenTech Solutions Launches Initiative to Reduce Carbon Footprint
Source: Sustainable Business News
Date: October 20, 2025

GreenTech Solutions, a global leader in <mark>renewable</mark> energy, has announced a new initiative to reduce its <mark>carbon footprint</mark> by 50% over the next decade. The initiative, named "GreenFuture 2035," focuses on enhancing sustainable production processes and investing in clean energy sources.

As part of this commitment, GreenTech Solutions will transition its manufacturing facilities to 100% solar and wind energy by 2028. Additionally, the company plans to introduce a new line of fully recyclable consumer electronics by 2026.

"We believe sustainability should be at the core of technological innovation," said Eleanor Hughes, CEO of GreenTech Solutions. "Through our GreenFuture 2035 initiative, we aim to lead the industry toward a cleaner and more responsible future."

Key Initiative Goals:
• Reduce greenhouse gas emissions by 50% by 2035
• Expand research on <mark>biodegradable</mark> electronic materials
• Partner with non-profits to promote environmental awareness

Industry analysts predict that this initiative will strengthen GreenTech's position as an industry leader in eco-friendly technology while encouraging other companies to adopt similar strategies.`,

  translation: `그린테크 솔루션즈, 탄소배출량 감축 계획 발표
출처: 지속가능 비즈니스 뉴스
날짜: 2025년 10월 20일

재생에너지 분야의 세계적 선도기업인 그린테크 솔루션즈가 향후 10년간 자사의 탄소배출량을 50% 감축하는 새로운 계획을 발표했습니다. "그린퓨처 2035"로 명명된 이 계획은 지속가능한 생산 공정 개선과 청정에너지원 투자에 중점을 두고 있습니다.

이러한 약속의 일환으로, 그린테크 솔루션즈는 2028년까지 제조시설을 100% 태양광과 풍력 에너지로 전환할 예정입니다. 또한 2026년까지 완전 재활용 가능한 새로운 소비자 전자제품 라인을 도입할 계획입니다.

그린테크 솔루션즈의 CEO 엘리너 휴즈는 "지속가능성이 기술 혁신의 핵심이 되어야 한다고 믿습니다"라며, "그린퓨처 2035 계획을 통해 우리는 산업계를 더 깨끗하고 책임감 있는 미래로 이끌고자 합니다"라고 말했습니다.

주요 계획 목표:
• 2035년까지 온실가스 배출량 50% 감축
• 생분해성 전자 소재 연구 확대
• 환경 인식 제고를 위한 비영리단체와의 협력

업계 분석가들은 이 계획이 친환경 기술 분야에서 그린테크의 업계 선도적 위치를 강화하는 동시에 다른 기업들도 유사한 전략을 채택하도록 장려할 것으로 예측하고 있습니다.`,

  koreanNouns: `GreenTech Solutions Launches Initiative to Reduce Carbon Footprint
Source: Sustainable Business News
Date: October 20, 2025

GreenTech Solutions, a global leader in <mark>재생 가능한</mark> energy, has announced a new initiative to reduce its <mark>탄소 배출량</mark> by 50% over the next decade. The initiative, named "GreenFuture 2035," focuses on enhancing sustainable production processes and investing in clean energy sources.

As part of this commitment, GreenTech Solutions will transition its manufacturing facilities to 100% solar and wind energy by 2028. Additionally, the company plans to introduce a new line of fully recyclable consumer electronics by 2026.

"We believe sustainability should be at the core of technological innovation," said Eleanor Hughes, CEO of GreenTech Solutions. "Through our GreenFuture 2035 initiative, we aim to lead the industry toward a cleaner and more responsible future."

Key Initiative Goals:
• Reduce greenhouse gas emissions by 50% by 2035
• Expand research on <mark>생분해성의</mark> electronic materials
• Partner with non-profits to promote environmental awareness

Industry analysts predict that this initiative will strengthen GreenTech's position as an industry leader in eco-friendly technology while encouraging other companies to adopt similar strategies.`,

  wordPairs: {
    renewable: "재생 가능한",
    "carbon footprint": "탄소 배출량",
    biodegradable: "생분해성의",
  },

  questions: [],
};

const pressRelease19 = {
  id: 19,
  passage: `MedTech Innovations Unveils Breakthrough in Cancer <mark>Detection</mark>
Source: Medical Science Today
Date: November 5, 2025

MedTech Innovations, a leading biotechnology firm, has announced a major breakthrough in cancer detection. The company's newly developed AI-driven diagnostic tool, BioScan-X, can detect early-stage cancer with 98% accuracy, significantly improving early diagnosis rates.

The BioScan-X system, developed <mark>in collaboration with</mark> Harvard Medical Research Institute, utilizes deep learning algorithms to analyze blood samples in real-time. This innovation is expected to reduce diagnostic time from weeks to mere hours.

"This advancement represents a significant step forward in the fight against cancer," said Dr. Emily Chen, Chief Medical Officer at MedTech Innovations. "Our goal is to make early detection more accessible, ultimately saving more lives."

Future Development Plans:
• Obtain FDA approval by mid-2026
• Expand clinical trials across Europe and North America
• Partner with major hospitals for real-world testing

Medical professionals and researchers have hailed BioScan-X as a game-changer, predicting that it could become the standard for early cancer detection worldwide.`,

  translation: `메드테크 이노베이션스, 암 진단 분야의 획기적 발전 공개
출처: 메디컬 사이언스 투데이
날짜: 2025년 11월 5일

선도적인 생명공학 기업인 메드테크 이노베이션스가 암 진단 분야의 중대한 돌파구를 발표했습니다. 회사가 새롭게 개발한 AI 기반 진단 도구인 바이오스캔-X는 98%의 정확도로 초기 암을 감지할 수 있어, 조기 진단율을 크게 향상시킬 것으로 기대됩니다.

하버드 의학연구소와 협력하여 개발된 바이오스캔-X 시스템은 딥러닝 알고리즘을 활용하여 실시간으로 혈액 샘플을 분석합니다. 이 혁신은 진단 시간을 몇 주에서 단 몇 시간으로 단축할 것으로 예상됩니다.

메드테크 이노베이션스의 최고의료책임자인 에밀리 첸 박사는 "이번 발전은 암과의 싸움에서 중요한 진전을 의미합니다"라며, "우리의 목표는 조기 진단을 더욱 접근하기 쉽게 만들어 궁극적으로 더 많은 생명을 구하는 것입니다"라고 말했습니다.

향후 개발 계획:
• 2026년 중반까지 FDA 승인 획득
• 유럽과 북미 전역으로 임상시험 확대
• 실제 테스트를 위한 주요 병원들과의 협력

의료 전문가들과 연구진들은 바이오스캔-X를 게임체인저로 평가하며, 전 세계적으로 조기 암 진단의 표준이 될 수 있을 것으로 예측하고 있습니다.`,

  koreanNouns: `MedTech Innovations Unveils Breakthrough in Cancer <mark>진단</mark>
Source: Medical Science Today
Date: November 5, 2025

MedTech Innovations, a leading biotechnology firm, has announced a major breakthrough in cancer detection. The company's newly developed AI-driven diagnostic tool, BioScan-X, can detect early-stage cancer with 98% accuracy, significantly improving early diagnosis rates.

The BioScan-X system, developed <mark>협력하여</mark> Harvard Medical Research Institute, utilizes deep learning algorithms to analyze blood samples in real-time. This innovation is expected to reduce diagnostic time from weeks to mere hours.

"This advancement represents a significant step forward in the fight against cancer," said Dr. Emily Chen, Chief Medical Officer at MedTech Innovations. "Our goal is to make early detection more accessible, ultimately saving more lives."

Future Development Plans:
• Obtain FDA approval by mid-2026
• Expand clinical trials across Europe and North America
• Partner with major hospitals for real-world testing

Medical professionals and researchers have hailed BioScan-X as a game-changer, predicting that it could become the standard for early cancer detection worldwide.`,

  wordPairs: {
    Detection: "진단",
    "in collaboration with": "협력하여",
  },

  questions: [],
};

const pressRelease20 = {
  id: 20,
  passage: `Grand Foods, one of the largest <mark>grocery retailers</mark> in the country, has finalized its <mark>acquisition</mark> of FreshHarvest Markets, a regional supermarket chain known for its focus on organic and locally sourced products. The $1.8 billion deal is expected to expand Grand Foods' presence in the organic food sector and enhance its supply chain efficiency.

With this <mark>acquisition</mark>, FreshHarvest's 120 store locations will be rebranded under the Grand Foods name while maintaining their commitment to fresh, sustainable products. "This merger allows us to bring high-quality, organic foods to more communities while streamlining our operations," said Grand Foods CEO Melissa Carter.

Industry experts suggest that the deal will enable Grand Foods to compete more effectively with national grocery chains like Whole Foods and Trader Joe's. The transition is set to begin in early 2026, with full <mark>integration</mark> expected by the end of the year.`,

  translation: `그랜드푸드, 프레시하베스트 마켓 인수 완료
국내 최대 식료품 소매업체 중 하나인 그랜드푸드가 유기농 및 지역 농산물에 중점을 둔 지역 슈퍼마켓 체인인 프레시하베스트 마켓의 인수를 완료했습니다. 18억 달러 규모의 이번 거래는 그랜드푸드의 유기농 식품 부문 입지를 확대하고 공급망 효율성을 향상시킬 것으로 예상됩니다.

이번 인수로 프레시하베스트의 120개 매장은 신선하고 지속 가능한 제품에 대한 약속을 유지하면서 그랜드푸드의 이름으로 리브랜딩될 예정입니다. 멜리사 카터 그랜드푸드 CEO는 "이번 합병을 통해 운영을 효율화하면서 더 많은 지역사회에 고품질 유기농 식품을 제공할 수 있게 되었다"고 말했습니다.

업계 전문가들은 이번 거래로 그랜드푸드가 홀푸드나 트레이더조스와 같은 전국 규모의 식료품 체인들과 더욱 효과적으로 경쟁할 수 있게 될 것이라고 제안합니다. 전환 작업은 2026년 초에 시작되어 연말까지 완전한 통합이 이루어질 것으로 예상됩니다.`,

  koreanNouns: `Grand Foods, one of the largest <mark>식료품 소매업체</mark> in the country, has finalized its <mark>인수</mark> of FreshHarvest Markets, a regional supermarket chain known for its focus on organic and locally sourced products. The $1.8 billion deal is expected to expand Grand Foods' presence in the organic food sector and enhance its supply chain efficiency.

With this <mark>인수</mark>, FreshHarvest's 120 store locations will be rebranded under the Grand Foods name while maintaining their commitment to fresh, sustainable products. "This merger allows us to bring high-quality, organic foods to more communities while streamlining our operations," said Grand Foods CEO Melissa Carter.

Industry experts suggest that the deal will enable Grand Foods to compete more effectively with national grocery chains like Whole Foods and Trader Joe's. The transition is set to begin in early 2026, with full <mark>통합</mark> expected by the end of the year.`,
  wordPairs: {
    "식료품 소매업체": "grocery retailers",
    인수: "acquisition",
    통합: "integration",
  },

  questions: [],
};

const pressRelease21 = {
  id: 21,
  passage: `GoldenBrew, a leading coffee brand, has launched its highly anticipated line of premium cold brew coffee, featuring all-natural ingredients and a smoother taste. The new product range includes three varieties: Classic Black, Vanilla Almond, and Mocha Hazelnut.

The company developed the line in response to growing consumer demand for high-quality, ready-to-drink coffee. Unlike traditional iced coffee, GoldenBrew's cold brew is <mark>steeped</mark> for 18 hours, resulting in a less acidic and naturally sweet flavor.

"Consumers today are looking for convenience without sacrificing quality," said Laura Mitchell, GoldenBrew's Chief Product Officer. "Our cold brew offers a rich, smooth taste with no artificial additives, making it the perfect choice for coffee lovers on the go."

The new cold brew line is now available in supermarkets and convenience stores <mark>nationwide</mark>, with plans to expand into international markets by early 2026.`,

  translation: `골든브루, 프리미엄 콜드브루 커피 라인 출시
선도적인 커피 브랜드인 골든브루가 천연 재료와 부드러운 맛을 특징으로 하는 기대가 높았던 프리미엄 콜드브루 커피 라인을 출시했습니다. 새로운 제품군은 클래식 블랙, 바닐라 아몬드, 모카 헤이즐넛 세 가지 종류를 포함합니다.

이 회사는 고품질의 바로 마실 수 있는 커피에 대한 증가하는 소비자 수요에 대응하여 이 라인을 개발했습니다. 전통적인 아이스 커피와 달리, 골든브루의 콜드브루는 18시간 동안 우려내어 산도가 낮고 자연스러운 단맛을 내는 결과를 얻었습니다.

로라 미첼 골든브루 최고제품책임자는 "오늘날의 소비자들은 품질을 희생하지 않으면서도 편의성을 찾고 있습니다"라고 말했습니다. "우리의 콜드브루는 인공 첨가물 없이 풍부하고 부드러운 맛을 제공하여, 바쁜 커피 애호가들에게 완벽한 선택이 될 것입니다."

새로운 콜드브루 라인은 현재 전국의 슈퍼마켓과 편의점에서 구매할 수 있으며, 2026년 초까지 국제 시장으로 확장할 계획입니다.`,

  koreanNouns: `GoldenBrew, a leading coffee brand, has launched its highly anticipated line of premium cold brew coffee, featuring all-natural ingredients and a smoother taste. The new product range includes three varieties: Classic Black, Vanilla Almond, and Mocha Hazelnut.

The company developed the line in response to growing consumer demand for high-quality, ready-to-drink coffee. Unlike traditional iced coffee, GoldenBrew's cold brew is <mark>우려내다</mark> for 18 hours, resulting in a less acidic and naturally sweet flavor.

"Consumers today are looking for convenience without sacrificing quality," said Laura Mitchell, GoldenBrew's Chief Product Officer. "Our cold brew offers a rich, smooth taste with no artificial additives, making it the perfect choice for coffee lovers on the go."

The new cold brew line is now available in supermarkets and convenience stores <mark>전국적으로</mark>, with plans to expand into international markets by early 2026.`,
  wordPairs: {
    우려내다: "steeped",
    전국적으로: "nationwide",
  },

  questions: [],
};

const pressRelease22 = {
  id: 22,
  passage: `The bestselling mystery novel The Forgotten City is set to hit the big screen, as Silverline Studios has officially announced its <mark>adaptation</mark> of the critically <mark>acclaimed</mark> book. The film, directed by award-winning filmmaker David Lin, is scheduled for release in late 2026.

The novel, written by Emma Caldwell, follows a journalist who uncovers a long-buried secret in a <mark>seemingly</mark> perfect town. Since its release in 2023, the book has sold over five million copies <mark>worldwide</mark> and has been translated into 12 languages.

"Bringing this story to life on screen is a dream come true," said Caldwell. "I can't wait to see how the characters and setting come alive in a cinematic format."

Filming is set to begin in early 2026, with casting decisions expected to be announced in the coming months. Industry experts predict that The Forgotten City could become one of the most highly anticipated literary adaptations of the decade.`,

  translation: `베스트셀러 미스터리 소설 '잊혀진 도시', 영화화 확정
실버라인 스튜디오가 호평받은 소설의 각색을 공식 발표하면서 베스트셀러 미스터리 소설 '잊혀진 도시'가 스크린에 오르게 됩니다. 수상 경력이 있는 영화감독 데이비드 린이 연출하는 이 영화는 2026년 말 개봉 예정입니다.

엠마 콜드웰이 쓴 이 소설은 겉보기에 완벽해 보이는 마을에서 오랫동안 묻혀있던 비밀을 밝혀내는 한 기자의 이야기를 다룹니다. 2023년 출간 이후 전 세계적으로 500만 부 이상 판매되었으며 12개 언어로 번역되었습니다.

콜드웰은 "이 이야기를 스크린에서 생명력을 갖게 하는 것은 꿈이 이루어진 것"이라고 말했습니다. "캐릭터들과 배경이 영화적 형식으로 어떻게 살아날지 정말 기대됩니다."

촬영은 2026년 초에 시작될 예정이며, 캐스팅 결정은 앞으로 몇 달 안에 발표될 것으로 예상됩니다. 업계 전문가들은 '잊혀진 도시'가 이번 10년간 가장 기대되는 문학 각색 작품 중 하나가 될 것으로 예측합니다.`,

  koreanNouns: `The bestselling mystery novel The Forgotten City is set to hit the big screen, as Silverline Studios has officially announced its <mark>각색</mark> of the critically <mark>호평받은</mark> book. The film, directed by award-winning filmmaker David Lin, is scheduled for release in late 2026.

The novel, written by Emma Caldwell, follows a journalist who uncovers a long-buried secret in a <mark>겉보기에</mark> perfect town. Since its release in 2023, the book has sold over five million copies <mark>전 세계적으로</mark> and has been translated into 12 languages.

"Bringing this story to life on screen is a dream come true," said Caldwell. "I can't wait to see how the characters and setting come alive in a cinematic format."

Filming is set to begin in early 2026, with casting decisions expected to be announced in the coming months. Industry experts predict that The Forgotten City could become one of the most highly anticipated literary adaptations of the decade.`,
  wordPairs: {
    adaptation: "각색",
    acclaimed: "호평받은",
    seemingly: "겉보기에",
    worldwide: "전 세계적으로",
  },

  questions: [],
};

const pressRelease23 = {
  id: 23,
  passage: `Greenfield Launches Urban Tree Planting Program
By Rachel Monroe

The Greenfield City Council has introduced an ambitious initiative to expand urban green spaces and improve air quality. 
The program aims to plant thousands of trees across parks, sidewalks, and public areas over the next three years.

City officials have emphasized the importance of increasing tree coverage to <mark>counteract</mark> rising temperatures and reduce pollution levels. 
"More trees mean better air quality and lower energy costs for residents," said Mayor David Collins. He further explained that the city will provide <mark>subsidies</mark> for homeowners who plant trees on their properties, provided they maintain them for at least two years.

Rapid urban development has contributed to declining tree numbers, leading to increased heat retention and poorer air quality in densely <mark>populated</mark> areas. As a result, the city has allocated $12 million toward tree planting efforts, maintenance programs, and educational initiatives to encourage community participation.

Officials expect the first phase of planting to be completed by early next year, with continuous monitoring to ensure tree survival and long-term environmental benefits.`,

  translation: `그린필드, 도시 나무 심기 프로그램 시작
레이첼 먼로 기자

그린필드 시의회가 도시 녹지 공간을 확장하고 대기질을 개선하기 위한 야심찬 계획을 도입했습니다. 이 프로그램은 향후 3년 동안 공원, 보도 및 공공 장소 전역에 수천 그루의 나무를 심는 것을 목표로 합니다.

시 관계자들은 기온 상승을 억제하고 오염 수준을 줄이기 위해 나무 피복률을 높이는 것의 중요성을 강조했습니다. "더 많은 나무는 더 나은 대기질과 주민들의 에너지 비용 절감을 의미합니다"라고 데이비드 콜린스 시장이 말했습니다. 그는 또한 시에서 자신의 부지에 나무를 심는 주택 소유자들에게 보조금을 제공할 것이라고 설명했으며, 단 최소 2년 동안 나무를 관리해야 한다는 조건이 있습니다.

급속한 도시 개발로 인해 나무 수가 감소하여 인구 밀집 지역의 열 보존이 증가하고 대기질이 악화되었습니다. 이에 따라 시는 나무 심기 노력, 유지 관리 프로그램 및 지역사회 참여를 장려하기 위한 교육 이니셔티브에 1,200만 달러를 할당했습니다.

관계자들은 내년 초까지 첫 번째 식재 단계가 완료될 것으로 예상하며, 나무의 생존과 장기적인 환경 혜택을 보장하기 위해 지속적인 모니터링을 실시할 것입니다.`,
  koreanNouns: `Greenfield Launches Urban Tree Planting Program
By Rachel Monroe

The Greenfield City Council has introduced an ambitious initiative to expand urban green spaces and improve air quality. 
The program aims to plant thousands of trees across parks, sidewalks, and public areas over the next three years.

City officials have emphasized the importance of increasing tree coverage to <mark>상쇄하다</mark> rising temperatures and reduce pollution levels. 
"More trees mean better air quality and lower energy costs for residents," said Mayor David Collins. He further explained that the city will provide <mark>보조금</mark> for homeowners who plant trees on their properties, provided they maintain them for at least two years.

Rapid urban development has contributed to declining tree numbers, leading to increased heat retention and poorer air quality in densely <mark>인구 밀집된</mark> areas. As a result, the city has allocated $12 million toward tree planting efforts, maintenance programs, and educational initiatives to encourage community participation.

Officials expect the first phase of planting to be completed by early next year, with continuous monitoring to ensure tree survival and long-term environmental benefits.`,
  wordPairs: {
    counteract: "상쇄하다",
    subsidies: "보조금",
    populated: "인구 밀집된",
  },

  questions: [],
};

const pressRelease24 = {
  id: 24,
  passage: `Lakeside Introduces Comprehensive Flood Prevention Plan
By Thomas Reynolds

The Lakeside City Council has <mark>unveiled</mark> a large-scale flood prevention initiative aimed at protecting residents and businesses from <mark>recurring</mark> seasonal floods. The plan involves reinforcing existing drainage systems, constructing flood barriers, and upgrading critical infrastructure in high-risk areas.

"Flooding has become a growing concern in recent years, and we must take <mark>proactive</mark> steps to safeguard the community," said Mayor Angela Wright. She further explained that homeowners in <mark>designated</mark> flood zones will be eligible for financial assistance to install <mark>water-resistant</mark> features, such as raised foundations and improved drainage systems.

Unusually heavy rainfall and outdated infrastructure have led to severe flood damage in recent years. The cost of repairs has placed a significant financial burden on both the city and affected residents. To address these challenges, the city has committed $15 million to implement flood prevention <mark>measures</mark>, improve emergency response plans, and enhance public <mark>awareness</mark> about flood safety.

The initial phase of the project is expected to begin next month, with key improvements scheduled for completion within two years. <mark>Officials</mark> will closely monitor progress and make necessary adjustments to ensure long-term effectiveness.`,

  translation: `레이크사이드, 종합적인 홍수 예방 계획 도입
토마스 레이놀즈 기자

레이크사이드 시의회가 주민과 기업을 반복되는 계절성 홍수로부터 보호하기 위한 대규모 홍수 예방 이니셔티브를 공개했습니다. 이 계획은 기존 배수 시스템 강화, 홍수 방벽 건설, 고위험 지역의 중요 인프라 업그레이드를 포함합니다.

"홍수는 최근 몇 년간 증가하는 우려사항이 되었으며, 우리는 지역사회를 보호하기 위해 사전 예방적 조치를 취해야 합니다"라고 안젤라 라이트 시장이 말했습니다. 그녀는 또한 지정된 홍수 구역의 주택 소유자들이 높아진 기초와 개선된 배수 시스템과 같은 내수성 기능을 설치하기 위한 재정 지원을 받을 자격이 있다고 설명했습니다.

비정상적으로 많은 강우량과 노후화된 인프라로 인해 최근 몇 년간 심각한 홍수 피해가 발생했습니다. 수리 비용은 시와 피해를 입은 주민 모두에게 상당한 재정적 부담을 안겼습니다. 이러한 과제를 해결하기 위해 시는 홍수 예방 조치 시행, 비상 대응 계획 개선, 홍수 안전에 대한 대중 인식 향상을 위해 1,500만 달러를 투입하기로 약속했습니다.

프로젝트의 초기 단계는 다음 달에 시작될 예정이며, 주요 개선 사항은 2년 내에 완료될 예정입니다. 관계자들은 진행 상황을 면밀히 모니터링하고 장기적인 효과를 보장하기 위해 필요한 조정을 할 것입니다.`,
  koreanNouns: `Lakeside Introduces Comprehensive Flood Prevention Plan
By Thomas Reynolds

The Lakeside City Council has <mark>공개했다.</mark> a large-scale flood prevention initiative aimed at protecting residents and businesses from <mark>반복되는</mark> seasonal floods. The plan involves reinforcing existing drainage systems, constructing flood barriers, and upgrading critical infrastructure in high-risk areas.

"Flooding has become a growing concern in recent years, and we must take <mark>미리 대응하는</mark> steps to safeguard the community," said Mayor Angela Wright. She further explained that homeowners in <mark>지정된</mark> flood zones will be eligible for financial assistance to install <mark>내수성</mark> features, such as raised foundations and improved drainage systems.

Unusually heavy rainfall and outdated infrastructure have led to severe flood damage in recent years. The cost of repairs has placed a significant financial burden on both the city and affected residents. To address these challenges, the city has committed $15 million to implement flood prevention <mark>조치</mark>, improve emergency response plans, and enhance public <mark>인식</mark> about flood safety.

The initial phase of the project is expected to begin next month, with key improvements scheduled for completion within two years. <mark>관계자들</mark> will closely monitor progress and make necessary adjustments to ensure long-term effectiveness.`,
  wordPairs: {
    unveiled: "공개했다.",
    recurring: "반복되는",
    proactive: "미리 대응하는",
    designated: "지정된",
    "water-resistant": "내수성",
    measures: "조치",
    awareness: "인식",
    Officials: "관계자들",
  },

  questions: [],
};

const pressRelease25 = {
  id: 25,
  passage: `Rise of Subscription-Based Retail Alters Consumer Spending Habits

  San Francisco, November 3, 2025 – The retail landscape is <mark>undergoing</mark> a major transformation as subscription-based shopping models gain traction across a wide range of industries. Consumers are increasingly <mark>opting</mark> for monthly or annual subscription services for everything from groceries and clothing to personal care products and entertainment.

According to a report by the Global Consumer Insights Group, subscription-based retail sales have increased by 38% over the past two years, largely driven by younger <mark>demographics</mark> who prioritize convenience and personalized shopping experiences. Industry analysts attribute this shift to the appeal of predictable costs, exclusive member benefits, and automatic <mark>replenishment</mark> services, which eliminate the need for frequent store visits.

Major companies, including fashion retailers, meal-kit providers, and beauty brands, have capitalized on this trend by offering customized product deliveries tailored to individual preferences. LuxeStyle, a high-end fashion subscription company, reports that nearly 70% of its subscribers renew their memberships annually, citing curated selections and priority access to new collections as key factors.

Despite its popularity, the model is not without challenges. Some customers have raised concerns about subscription fatigue, as they struggle to manage multiple recurring payments. Others worry about limited flexibility, particularly when products do not meet expectations but are non-refundable. To address these issues, some companies have begun offering pause and cancellation options, allowing consumers greater control over their subscriptions.

Experts predict that while the subscription economy will continue to expand, retailers must balance <mark>exclusivity</mark> with flexibility to <mark>retain</mark> long-term customer loyalty.`,

  translation: `구독 기반 소매업이 소비자 지출 습관을 변화시키다
샌프란시스코, 2025년 11월 3일 – 구독 기반 쇼핑 모델이 다양한 산업 전반에 걸쳐 인기를 얻으면서 소매 시장이 큰 변화를 겪고 있습니다. 소비자들은 식료품, 의류에서부터 개인 관리 제품과 엔터테인먼트에 이르기까지 모든 것에 대해 월간 또는 연간 구독 서비스를 점점 더 선호하고 있습니다.

글로벌 소비자 인사이트 그룹의 보고서에 따르면, 구독 기반 소매 판매가 지난 2년간 38% 증가했으며, 이는 주로 편의성과 개인화된 쇼핑 경험을 중시하는 젊은 층에 의해 주도되었습니다. 업계 분석가들은 이러한 변화가 예측 가능한 비용, 독점적인 회원 혜택, 그리고 잦은 매장 방문의 필요성을 없애주는 자동 보충 서비스의 매력 때문이라고 분석합니다.

패션 소매업체, 밀키트 제공업체, 뷰티 브랜드를 포함한 주요 기업들은 개인의 선호도에 맞춘 맞춤형 제품 배송을 제공함으로써 이러한 트렌드를 활용해왔습니다. 고급 패션 구독 기업인 럭스스타일은 큐레이션된 선별 제품과 새로운 컬렉션에 대한 우선 접근권이 주요 요인이 되어 구독자의 약 70%가 매년 멤버십을 갱신한다고 보고했습니다.

인기에도 불구하고, 이 모델에는 과제가 없지 않습니다. 일부 고객들은 여러 반복 결제를 관리하는 데 어려움을 겪으면서 구독 피로감에 대한 우려를 제기했습니다. 다른 이들은 특히 제품이 기대에 미치지 못하지만 환불이 불가능한 경우 제한된 유연성에 대해 우려합니다. 이러한 문제를 해결하기 위해 일부 기업들은 소비자들에게 구독에 대한 더 큰 통제권을 제공하는 일시 중지 및 취소 옵션을 제공하기 시작했습니다.

전문가들은 구독 경제가 계속 확장될 것이지만, 소매업체들이 장기적인 고객 충성도를 유지하기 위해서는 배타성과 유연성 사이의 균형을 맞춰야 할 것이라고 예측합니다.`,

  koreanNouns: `Rise of Subscription-Based Retail Alters Consumer Spending Habits

  San Francisco, November 3, 2025 – The retail landscape is <mark>겪고 있다</mark> a major transformation as subscription-based shopping models gain traction across a wide range of industries. Consumers are increasingly <mark>선호한다</mark> for monthly or annual subscription services for everything from groceries and clothing to personal care products and entertainment.

According to a report by the Global Consumer Insights Group, subscription-based retail sales have increased by 38% over the past two years, largely driven by younger <mark>층</mark> who prioritize convenience and personalized shopping experiences. Industry analysts attribute this shift to the appeal of predictable costs, exclusive member benefits, and automatic <mark>보충</mark> services, which eliminate the need for frequent store visits.

Major companies, including fashion retailers, meal-kit providers, and beauty brands, have capitalized on this trend by offering customized product deliveries tailored to individual preferences. LuxeStyle, a high-end fashion subscription company, reports that nearly 70% of its subscribers renew their memberships annually, citing curated selections and priority access to new collections as key factors.

Despite its popularity, the model is not without challenges. Some customers have raised concerns about subscription fatigue, as they struggle to manage multiple recurring payments. Others worry about limited flexibility, particularly when products do not meet expectations but are non-refundable. To address these issues, some companies have begun offering pause and cancellation options, allowing consumers greater control over their subscriptions.

Experts predict that while the subscription economy will continue to expand, retailers must balance <mark>독점성</mark> with flexibility to <mark>유지하다</mark> long-term customer loyalty.`,
  wordPairs: {
    undergoing: "겪고 있다",
    opting: "선호한다",
    demographics: "층",
    replenishment: "보충",
    exclusivity: "독점성",
    retain: "유지하다",
  },

  questions: [],
};
const pressRelease26 = {
  id: 26,
  passage: `Entrepreneur Jane Whitmore Turns Local Coffee Shop into Global Brand
Source: Business Leaders Magazine
Date: November 3, 2025

By: Daniel Foster, Senior Business Correspondent

When Jane Whitmore opened a small coffee shop in Seattle ten years ago, she never imagined it would grow into Brew & Beyond, a global coffee chain with over 500 locations across 15 countries.

From a Single Café to an International Brand
Whitmore started her first café with a simple goal: to create a space where people could enjoy high-quality, <mark>ethically</mark> sourced coffee in a welcoming environment. Her unique approach—offering locally roasted beans and introducing a "slow brew" experience—quickly attracted a loyal customer <mark>base</mark>.

Challenges and Breakthroughs
"In the early days, I struggled to <mark>secure</mark> funding. Banks weren't convinced that a boutique coffee shop could compete with industry giants," Whitmore recalls. However, after partnering with a sustainable coffee farm in Colombia and securing a $1 million investment, Brew & Beyond expanded rapidly.

Future Growth
Now, Whitmore is focusing on eco-friendly initiatives, including <mark>compostable</mark> packaging and a <mark>carbon-neutral</mark> supply chain. She also plans to launch an online subscription service for customers who want freshly roasted coffee delivered to their homes.

"Success isn't just about numbers; it's about staying true to your values," she says. "If you focus on quality and innovation, growth will follow."`,

  translation: `기업가 제인 휘트모어, 지역 커피숍을 글로벌 브랜드로 성장시키다
출처: 비즈니스 리더스 매거진
날짜: 2025년 11월 3일

작성자: 다니엘 포스터, 수석 비즈니스 기자

제인 휘트모어가 10년 전 시애틀에 작은 커피숍을 열었을 때, 그녀는 그것이 15개국에 500개 이상의 매장을 가진 글로벌 커피 체인인 브루 & 비욘드로 성장할 것이라고는 상상도 하지 못했습니다.

단일 카페에서 국제 브랜드로
휘트모어는 사람들이 편안한 환경에서 고품질의 윤리적으로 조달된 커피를 즐길 수 있는 공간을 만든다는 단순한 목표로 첫 카페를 시작했습니다. 현지에서 로스팅한 원두를 제공하고 "슬로우 브루" 경험을 도입하는 그녀의 독특한 접근 방식은 빠르게 충성 고객층을 확보했습니다.

도전과 돌파구
"초기에는 자금 확보에 어려움을 겪었습니다. 은행들은 부티크 커피숍이 업계 거인들과 경쟁할 수 있다는 것을 확신하지 못했죠"라고 휘트모어는 회상합니다. 하지만 콜롬비아의 지속 가능한 커피 농장과 제휴하고 100만 달러의 투자를 확보한 후, 브루 & 비욘드는 급속히 확장되었습니다.

미래 성장
현재 휘트모어는 퇴비화 가능한 포장재와 탄소 중립 공급망을 포함한 친환경 계획에 집중하고 있습니다. 또한 갓 로스팅한 커피를 집으로 배달받기 원하는 고객들을 위한 온라인 구독 서비스도 출시할 계획입니다.

"성공은 단순히 숫자에 관한 것이 아닙니다. 자신의 가치관에 충실히 하는 것이죠"라고 그녀는 말합니다. "품질과 혁신에 집중하면 성장은 따라올 것입니다."`,
  koreanNouns: `Entrepreneur Jane Whitmore Turns Local Coffee Shop into Global Brand
Source: Business Leaders Magazine
Date: November 3, 2025

By: Daniel Foster, Senior Business Correspondent

When Jane Whitmore opened a small coffee shop in Seattle ten years ago, she never imagined it would grow into Brew & Beyond, a global coffee chain with over 500 locations across 15 countries.

From a Single Café to an International Brand
Whitmore started her first café with a simple goal: to create a space where people could enjoy high-quality, <mark>윤리적으로</mark> sourced coffee in a welcoming environment. Her unique approach—offering locally roasted beans and introducing a "slow brew" experience—quickly attracted a loyal customer <mark>기반</mark>.

Challenges and Breakthroughs
"In the early days, I struggled to <mark>확보하다</mark> funding. Banks weren't convinced that a boutique coffee shop could compete with industry giants," Whitmore recalls. However, after partnering with a sustainable coffee farm in Colombia and securing a $1 million investment, Brew & Beyond expanded rapidly.

Future Growth
Now, Whitmore is focusing on eco-friendly initiatives, including <mark>퇴비화 가능한</mark> packaging and a <mark>탄소 중립</mark> supply chain. She also plans to launch an online subscription service for customers who want freshly roasted coffee delivered to their homes.

"Success isn't just about numbers; it's about staying true to your values," she says. "If you focus on quality and innovation, growth will follow."`,
  wordPairs: {
    ethically: "윤리적으로",
    base: "기반",
    secure: "확보하다",
    "carbon-neutral": "탄소 중립",
    compostable: "퇴비화 가능한",
  },

  questions: [],
};
export const pressReleaseQuestions = [
  pressRelease1,
  pressRelease2,
  pressRelease3,
  pressRelease4,
  pressRelease5,
  pressRelease6,
  pressRelease7,
  pressRelease8,
  pressRelease9,
  pressRelease10,
  pressRelease11,
  pressRelease12,
  pressRelease13,
  pressRelease14,
  pressRelease15,
  pressRelease16,
  pressRelease17,
  pressRelease18,
  pressRelease19,
  pressRelease20,
  pressRelease21,
  pressRelease22,
  pressRelease23,
  pressRelease24,
  pressRelease25,
  pressRelease26,
];
